// // import { yupResolver } from '@hookform/resolvers/yup';
// // import {
// //   Alert,
// //   Avatar,
// //   Box,
// //   Button,
// //   Card,
// //   CardContent,
// //   Chip,
// //   CircularProgress,
// //   Container,
// //   Divider,
// //   FormControl,
// //   FormControlLabel,
// //   FormLabel,
// //   Grid,
// //   InputAdornment,
// //   Paper,
// //   Radio,
// //   RadioGroup,
// //   Snackbar,
// //   TextField,
// //   Typography,
// //   useMediaQuery,
// //   useTheme
// // } from '@mui/material';
// // import { useAppSelector } from 'app/hooks';
// // import { useDrawer } from 'components/app/DrawerContext';
// // import React, { useEffect, useMemo, useState } from 'react';
// // import { Controller, useForm } from 'react-hook-form';
// // import {
// //   FaArrowRight,
// //   FaArrowUp,
// //   FaCalculator,
// //   FaCoins,
// //   FaMoneyBillWave,
// //   FaPiggyBank
// // } from 'react-icons/fa';
// // import { MdCancel as CancelIcon, MdPerson } from 'react-icons/md';
// // import { TbArrowsExchange } from 'react-icons/tb';
// // import { useDispatch, useSelector } from 'react-redux';
// // import { useNavigate } from 'react-router';
// // import axiosInstance from 'Services/APIService';
// // import {
// //   manageOperationsPercentage,
// //   selectLoading as selectConfigLoading
// // } from 'slices/fundManagementInvestment/fundManagementConfigurationSlice';
// // import {
// //   getLandingData,
// //   purchaseUnits,
// //   resetUnitsPurchaseStatus,
// //   selectError,
// //   selectLandingData,
// //   selectLandingDataStatus,
// //   selectLastUnitsPurchase,
// //   selectLoading,
// //   selectUnitsPurchaseStatus,
// //   type PurchaseUnitsPayload
// // } from 'slices/fundManagementInvestment/fundmanagementInvestmentSlice';
// // import { fetchRecords, type ListRecordsPayload } from 'slices/incomeExpenses/IncomeExpensesSlice';
// // import { RootState } from 'store';
// // import * as yup from 'yup';

// // // Local interfaces
// // interface Screening {
// //   employeeId: string;
// //   employeeName: string;
// //   email: string;
// //   avatar?: string;
// //   competency?: string;
// //   status: boolean;
// //   isDelete: boolean;
// // }

// // interface UnitClass {
// //   id: string;
// //   name: string;
// //   type: 'Income' | 'Growth';
// //   unitPrice: number;
// //   totalUnits: number;
// //   totalNAV: number;
// //   description: string;
// //   features: string[];
// //   riskLevel: string;
// //   minimumInvestment: number;
// //   subscriptionType: 'incomeUnits' | 'growthUnits';
// // }

// // interface SubscriptionFormData {
// //   investorName: string;
// //   investorsEmailId: string;
// //   investorAvatar: string;
// //   calculationType: 'amount' | 'units';
// //   purchaseUnits: number;
// //   totalInvestmentAmt: number;
// //   subscriptionType: 'incomeUnits' | 'growthUnits';
// // }

// // // Validation schema
// // const validationSchema = yup.object({
// //   investorName: yup
// //     .string()
// //     .required('Investor name is required')
// //     .min(2, 'Name must be at least 2 characters'),
// //   investorsEmailId: yup
// //     .string()
// //     .required('Email address is required')
// //     .email('Please enter a valid email address'),
// //   investorAvatar: yup.string().required('Avatar is required'),
// //   calculationType: yup
// //     .string()
// //     .oneOf(['amount', 'units'], 'Invalid calculation type')
// //     .required('Calculation type is required'),
// //   purchaseUnits: yup.number().positive('Units must be positive').required('Units are required'),
// //   totalInvestmentAmt: yup
// //     .number()
// //     .positive('Investment amount must be positive')
// //     .required('Investment amount is required'),
// //   subscriptionType: yup
// //     .string()
// //     .oneOf(['incomeUnits', 'growthUnits'], 'Invalid subscription type')
// //     .required('Purchase type is required')
// // });

// // const UnitPurchase: React.FC = () => {
// //   const dispatch = useDispatch();
// //   const theme = useTheme();
// //   const navigate = useNavigate();
// //   const isMobile = useMediaQuery(theme.breakpoints.down('md'));
// //   const { fundManagementAdminRight } = useDrawer();

// //   // Redux state - Fund Management
// //   const purchaseStatus = useSelector(selectUnitsPurchaseStatus);
// //   const loading = useSelector(selectLoading);
// //   const error = useSelector(selectError);
// //   const lastTransaction = useSelector(selectLastUnitsPurchase);
// //   const landingData = useSelector(selectLandingData);
// //   const landingDataStatus = useSelector(selectLandingDataStatus);

// //   // Config loading state
// //   const configLoading = useSelector(selectConfigLoading);

// //   // Capacity state
// //   const capacitySummary = useSelector((state: RootState) => state.incomeExpenses?.summary);
// //   const capacityLoading = useSelector((state: RootState) => state.incomeExpenses?.loading);

// //   // Temp: Empty screenings
// //   const screenings: Screening[] = [];

// //   // Project and service info
// //   const selectedProjectId = useAppSelector((state) => state.homeTilesServices.selectedProjectId);
// //   const selectedServiceTitle = useAppSelector((state) => {
// //     const title = state.serviceSelected.selectedServiceTitle || 'fundManagementInvestment';
// //     return title.replace(/\s+/g, '').replace(/^[A-Z]/, (m) => m.toLowerCase());
// //   });

// //   // Role management
// //   const [isAdmin, setIsAdmin] = useState(fundManagementAdminRight);

// //   // Get groupId from localStorage
// //   const getGroupId = () => {
// //     const selectedProject = JSON.parse(localStorage.getItem('selectedProject') || '{}') as {
// //       projectId?: string;
// //       projectName?: string;
// //       isAdmin?: boolean;
// //     };
// //     return selectedProject?.projectId || '';
// //   };

// //   // Load landing data
// //   useEffect(() => {
// //     const groupId = getGroupId();
// //     if (groupId) {
// //       console.log('Loading landing data for unit purchase...');
// //       dispatch(
// //         getLandingData({
// //           groupId: groupId,
// //           serviceId: 'fundManagementInvestment',
// //           isAdmin: isAdmin
// //         }) as any
// //       );
// //     }
// //   }, [dispatch, isAdmin]);

// //   // Load capacity data
// //   useEffect(() => {
// //     const projectId = selectedProjectId || getGroupId();
// //     if (projectId && selectedServiceTitle) {
// //       const payload: ListRecordsPayload = {
// //         group_id: projectId,
// //         service_id: 'Budgeting Tools',
// //         transaction_type: 'all',
// //         current_year: '2025',
// //         time_filter: null,
// //         page_size: 10,
// //         continuation_token: null
// //       };

// //       dispatch(fetchRecords(payload) as any);
// //       console.log('Fetching capacity data for unit purchase...');
// //     }
// //   }, [dispatch, selectedProjectId, selectedServiceTitle]);

// //   // Memoized unit classes
// //   const unitClasses = useMemo((): UnitClass[] => {
// //     const initialUnitClasses: UnitClass[] = [
// //       {
// //         id: 'initial-income',
// //         name: 'Income Units',
// //         type: 'Income',
// //         unitPrice: 1.0,
// //         totalUnits: 0,
// //         totalNAV: 0,
// //         description:
// //           'Conservative investment focused on regular income generation through quarterly distributions',
// //         features: [
// //           'Regular quarterly distributions',
// //           'Lower volatility',
// //           'Stable income stream',
// //           'Conservative investment approach'
// //         ],
// //         riskLevel: 'Conservative',
// //         minimumInvestment: 10000,
// //         subscriptionType: 'incomeUnits'
// //       },
// //       {
// //         id: 'initial-growth',
// //         name: 'Growth Units',
// //         type: 'Growth',
// //         unitPrice: 1.0,
// //         totalUnits: 0,
// //         totalNAV: 0,
// //         description:
// //           'Growth-focused investment for long-term capital appreciation with higher risk tolerance',
// //         features: [
// //           'Capital growth focus',
// //           'Higher growth potential',
// //           'Reinvested earnings',
// //           'Long-term wealth building'
// //         ],
// //         riskLevel: 'Moderate to High',
// //         minimumInvestment: 15000,
// //         subscriptionType: 'growthUnits'
// //       }
// //     ];

// //     let processedData = [...initialUnitClasses];

// //     if (landingDataStatus === 'succeeded' && Array.isArray(landingData) && landingData.length > 0) {
// //       try {
// //         landingData.forEach((unit: any) => {
// //           const hasValidData =
// //             unit.hasOwnProperty('unitType') &&
// //             unit.hasOwnProperty('unitPrice') &&
// //             unit.unitPrice !== undefined &&
// //             unit.unitPrice !== null &&
// //             unit.unitPrice !== '' &&
// //             (unit.unitType === 'growthUnits' || unit.unitType === 'incomeUnits');

// //           if (hasValidData) {
// //             const totalUnits = parseFloat(String(unit.totalUnitsHoldTillDate)) || 0;
// //             const unitPrice = parseFloat(String(unit.unitPrice)) || 1.0;
// //             const totalNAV = parseFloat(String(unit.NAV)) || 0;
// //             const totalCashUsed = parseFloat(String(unit.totalCashUsed)) || 0;

// //             const isIncomeUnit = unit.unitType === 'incomeUnits';
// //             const unitType = isIncomeUnit ? 'Income' : 'Growth';
// //             const unitName = isIncomeUnit ? 'Income Units' : 'Growth Units';

// //             const finalTotalNAV = totalCashUsed > 0 ? totalCashUsed : totalNAV;

// //             const processedUnit: UnitClass = {
// //               id: `live-${unit.unitType}`,
// //               name: unitName,
// //               type: unitType as 'Income' | 'Growth',
// //               unitPrice: unitPrice,
// //               totalUnits: totalUnits,
// //               totalNAV: finalTotalNAV,
// //               description: isIncomeUnit
// //                 ? 'Conservative investment focused on regular income generation through quarterly distributions'
// //                 : 'Growth-focused investment for long-term capital appreciation with higher risk tolerance',
// //               features: isIncomeUnit
// //                 ? [
// //                     'Regular quarterly distributions',
// //                     'Lower volatility',
// //                     'Stable income stream',
// //                     'Conservative investment approach'
// //                   ]
// //                 : [
// //                     'Capital growth focus',
// //                     'Higher growth potential',
// //                     'Reinvested earnings',
// //                     'Long-term wealth building'
// //                   ],
// //               riskLevel: isIncomeUnit ? 'Conservative' : 'Moderate to High',
// //               minimumInvestment: isIncomeUnit ? 10000 : 15000,
// //               subscriptionType: isIncomeUnit ? 'incomeUnits' : 'growthUnits'
// //             };

// //             const targetIndex = processedData.findIndex((item) => item.type === unitType);
// //             if (targetIndex !== -1) {
// //               processedData[targetIndex] = processedUnit;
// //               console.log(`Updated ${unitType} units with live data in purchase component`);
// //             }
// //           }
// //         });

// //         console.log('Final processed data for purchase:', processedData);
// //         return processedData;
// //       } catch (err) {
// //         console.error('Error processing API data:', err);
// //         return initialUnitClasses;
// //       }
// //     }

// //     console.log('Using initial unit classes for purchase - API not ready or no valid data');
// //     return initialUnitClasses;
// //   }, [landingData, landingDataStatus]);

// //   // Get logged-in user
// //   const loggedInUser = useMemo(() => {
// //     const loginInfo = localStorage.getItem('user-details');
// //     if (loginInfo) {
// //       try {
// //         const userDetails = JSON.parse(loginInfo);
// //         return {
// //           name: userDetails.name || '',
// //           email: userDetails.email || '',
// //           avatar: userDetails.avatar || ''
// //         };
// //       } catch (error) {
// //         console.error('Error parsing user details:', error);
// //         return { name: '', email: '', avatar: '' };
// //       }
// //     }
// //     return { name: '', email: '', avatar: '' };
// //   }, []);

// //   // Local state
// //   const [selectedUnitClass, setSelectedUnitClass] = useState<UnitClass | null>(null);
// //   const [showForm, setShowForm] = useState(false);
// //   const [search, setSearch] = useState('');
// //   const [avatarUrls, setAvatarUrls] = useState<{ [key: string]: string | null }>({});
// //   const [loggedUserAvatarUrl, setLoggedUserAvatarUrl] = useState<string | null>(null);
// //   const [snackbar, setSnackbar] = useState({
// //     open: false,
// //     message: '',
// //     severity: 'success' as 'success' | 'error' | 'info'
// //   });

// //   // State for operational fees fetched from API
// //   const [operationalFees, setOperationalFees] = useState<{
// //     incomeUnits: number;
// //     growthUnits: number;
// //   }>({
// //     incomeUnits: 0,
// //     growthUnits: 0
// //   });

// //   // State for tracking API call status
// //   const [feeLoadingStatus, setFeeLoadingStatus] = useState<
// //     'idle' | 'loading' | 'success' | 'error'
// //   >('idle');

// //   // Load logged user avatar
// //   useEffect(() => {
// //     const fetchLoggedUserAvatar = async () => {
// //       if (loggedInUser.avatar) {
// //         try {
// //           const response = await axiosInstance.get(
// //             `/avatar/get-avatar?path=${encodeURIComponent(loggedInUser.avatar)}`,
// //             { responseType: 'blob' }
// //           );
// //           const imageUrl = URL.createObjectURL(response.data);
// //           setLoggedUserAvatarUrl(imageUrl);
// //         } catch (error) {
// //           console.error('Error fetching logged user avatar:', error);
// //           setLoggedUserAvatarUrl(null);
// //         }
// //       }
// //     };
// //     fetchLoggedUserAvatar();

// //     return () => {
// //       if (loggedUserAvatarUrl) {
// //         URL.revokeObjectURL(loggedUserAvatarUrl);
// //       }
// //     };
// //   }, [loggedInUser.avatar]);

// //   // React Hook Form
// //   const {
// //     control,
// //     handleSubmit,
// //     watch,
// //     setValue,
// //     formState: { errors, isValid },
// //     reset
// //   } = useForm<SubscriptionFormData>({
// //     resolver: yupResolver(validationSchema),
// //     defaultValues: {
// //       investorName: loggedInUser.name,
// //       investorsEmailId: loggedInUser.email,
// //       investorAvatar: loggedInUser.avatar,
// //       calculationType: 'amount',
// //       purchaseUnits: 0,
// //       totalInvestmentAmt: 0,
// //       subscriptionType: 'incomeUnits'
// //     },
// //     mode: 'onChange'
// //   });

// //   const watchedValues = watch();

// //   const formatCurrency = (amount: number) => {
// //     if (typeof amount !== 'number' || isNaN(amount)) {
// //       return '$0';
// //     }

// //     const absAmount = Math.abs(amount);
// //     const isNegative = amount < 0;

// //     let formattedAmount: string;

// //     if (absAmount >= 1000000000) {
// //       formattedAmount = (absAmount / 1000000000).toFixed(3) + 'B';
// //     } else if (absAmount >= 1000000) {
// //       formattedAmount = (absAmount / 1000000).toFixed(3) + 'M';
// //     } else if (absAmount >= 1000) {
// //       formattedAmount = (absAmount / 1000).toFixed(3) + 'K';
// //     } else {
// //       formattedAmount = absAmount % 1 === 0 ? absAmount.toString() : absAmount.toFixed(3);
// //     }

// //     if (formattedAmount.includes('.')) {
// //       formattedAmount = formattedAmount.replace(/\.?0+$/, '');
// //     }

// //     const sign = isNegative ? '-' : '';
// //     return `${sign}$${formattedAmount}`;
// //   };

// //   // Load operational percentage dynamically from API when subscription type changes
// //   useEffect(() => {
// //     const loadOperationalPercentage = async () => {
// //       try {
// //         const projectId = selectedProjectId || getGroupId();

// //         setFeeLoadingStatus('loading');
// //         console.log(`Loading operational percentage for ${watchedValues.subscriptionType}...`);

// //         // Call API via Redux to get the percentage
// //         const result = await dispatch(
// //           manageOperationsPercentage({
// //             action: 'get',
// //             groupId: projectId,
// //             serviceId: 'fundManagementInvestment',
// //             unitType: watchedValues.subscriptionType,
// //             perType: 'buy'
// //           }) as any
// //         );

// //         // Extract percentage from Redux action response
// //         if (result.payload?.response?.data?.percentage !== undefined) {
// //           const percentage = result.payload.response.data.percentage;
// //           setOperationalFees((prev) => ({
// //             ...prev,
// //             [watchedValues.subscriptionType]: percentage
// //           }));
// //           setFeeLoadingStatus('success');
// //           console.log(`Operational fee loaded: ${watchedValues.subscriptionType} = ${percentage}%`);
// //         } else {
// //           setFeeLoadingStatus('error');
// //           console.warn('No percentage data in response');
// //         }
// //       } catch (error) {
// //         console.error('Error loading operational percentage:', error);
// //         setFeeLoadingStatus('error');
// //         setOperationalFees((prev) => ({
// //           ...prev,
// //           [watchedValues.subscriptionType]: 0
// //         }));
// //       }
// //     };

// //     if (watchedValues.subscriptionType && showForm) {
// //       loadOperationalPercentage();
// //     }
// //   }, [watchedValues.subscriptionType, showForm, dispatch, selectedProjectId]);

// //   // Get percentage from dynamically fetched state
// //   const operationPercentage = operationalFees[watchedValues.subscriptionType] || 0;

// //   // Calculate charge with dynamic percentage
// //   const operationCharge = useMemo(() => {
// //     const baseAmount = watchedValues.totalInvestmentAmt || 0;
// //     const charge = parseFloat((baseAmount * (operationPercentage / 100)).toFixed(2));
// //     return charge;
// //   }, [watchedValues.totalInvestmentAmt, operationPercentage]);

// //   const totalWithFee = useMemo(() => {
// //     const baseAmount = watchedValues.totalInvestmentAmt || 0;
// //     return parseFloat((baseAmount + operationCharge).toFixed(2));
// //   }, [watchedValues.totalInvestmentAmt, operationCharge]);

// //   // Capacity checks
// //   const checkCapacitySufficient = (requestedAmount: number): boolean => {
// //     if (!capacitySummary || typeof capacitySummary.my_capacity !== 'number') return false;
// //     return requestedAmount <= capacitySummary.my_capacity;
// //   };

// //   const getRemainingCapacity = (): number => {
// //     if (!capacitySummary || typeof capacitySummary.my_capacity !== 'number') {
// //       return 0;
// //     }
// //     return capacitySummary.my_capacity;
// //   };

// //   const getCapacityAfterPurchase = (requestedAmount: number): number => {
// //     const available = getRemainingCapacity();
// //     return available - requestedAmount;
// //   };

// //   const handleUnitClassSelect = (unitClass: UnitClass) => {
// //     console.log('Selected Unit Class:', unitClass);
// //     setSelectedUnitClass(unitClass);
// //     const minInvestment = unitClass.minimumInvestment;
// //     const calculatedUnits = minInvestment / unitClass.unitPrice;

// //     setValue('subscriptionType', unitClass.subscriptionType);
// //     setValue('totalInvestmentAmt', minInvestment);
// //     setValue('purchaseUnits', calculatedUnits);
// //     setValue('calculationType', 'amount');

// //     setShowForm(true);
// //   };

// //   const handleSelectSelf = () => {
// //     setValue('investorName', loggedInUser.name);
// //     setValue('investorsEmailId', loggedInUser.email);
// //     setValue('investorAvatar', loggedInUser.avatar);
// //   };

// //   const handleCalculationTypeChange = (type: 'amount' | 'units') => {
// //     if (!selectedUnitClass) return;

// //     setValue('calculationType', type);

// //     if (type === 'amount') {
// //       const currentAmount = watchedValues.totalInvestmentAmt || selectedUnitClass.minimumInvestment;
// //       const calculatedUnits = currentAmount / selectedUnitClass.unitPrice;
// //       setValue('purchaseUnits', calculatedUnits);
// //     } else {
// //       const currentUnits =
// //         watchedValues.purchaseUnits ||
// //         selectedUnitClass.minimumInvestment / selectedUnitClass.unitPrice;
// //       const calculatedAmount = currentUnits * selectedUnitClass.unitPrice;
// //       setValue('totalInvestmentAmt', calculatedAmount);
// //     }
// //   };

// //   const handleAmountChange = (amount: number) => {
// //     if (!selectedUnitClass) return;
// //     const calculatedUnits = amount / selectedUnitClass.unitPrice;
// //     setValue('purchaseUnits', calculatedUnits);
// //     setValue('totalInvestmentAmt', amount);
// //   };

// //   const handleUnitsChange = (units: number) => {
// //     if (!selectedUnitClass) return;
// //     const calculatedAmount = units * selectedUnitClass.unitPrice;
// //     setValue('totalInvestmentAmt', calculatedAmount);
// //     setValue('purchaseUnits', units);
// //   };

// //   // UPDATED: Submit handler with unitPrice and operationCharge in payload
// //   const onSubmit = async (data: SubscriptionFormData) => {
// //     if (!selectedUnitClass) return;

// //     const projectId = selectedProjectId || getGroupId();
// //     const requestedAmount = totalWithFee;
// //     const availableCapacity = getRemainingCapacity();

// //     if (requestedAmount > availableCapacity) {
// //       const shortfall = requestedAmount - availableCapacity;
// //       setSnackbar({
// //         open: true,
// //         message: `Insufficient Funds! You are requesting ${formatCurrency(
// //           requestedAmount
// //         )} but only have ${formatCurrency(availableCapacity)} available. You need ${formatCurrency(
// //           shortfall
// //         )} more capacity.`,
// //         severity: 'error'
// //       });
// //       return;
// //     }

// //     // UPDATED: Payload with unitPrice and operationCharge
// //     const payload: PurchaseUnitsPayload = {
// //       groupId: projectId,
// //       serviceId: 'fundManagementInvestment',
// //       investorsEmailId: data.investorsEmailId,
// //       investorName: data.investorName,
// //       investorAvatar: data.investorAvatar,
// //       purchaseUnits: data.purchaseUnits.toFixed(2),
// //       totalInvestmentAmt: data.totalInvestmentAmt.toFixed(2), // Pure amount without %
// //       unitPrice: selectedUnitClass.unitPrice.toFixed(2), // Current unit price
// //       operationCharge: operationCharge.toFixed(2), // Calculated % amount
// //       subscriptionType: data.subscriptionType
// //     };

// //     console.log('Submitting payload:', payload);

// //     try {
// //       const result = await dispatch(purchaseUnits(payload) as any);

// //       if (purchaseUnits.fulfilled.match(result)) {
// //         setSnackbar({
// //           open: true,
// //           message: 'Purchase request submitted successfully! Redirecting...',
// //           severity: 'success'
// //         });

// //         if (projectId && selectedServiceTitle) {
// //           const refreshPayload: ListRecordsPayload = {
// //             group_id: projectId,
// //             service_id: 'Budgeting Tools',
// //             transaction_type: 'all',
// //             current_year: '2025',
// //             time_filter: null,
// //             page_size: 10,
// //             continuation_token: null
// //           };

// //           dispatch(fetchRecords(refreshPayload) as any);
// //         }

// //         setTimeout(() => {
// //           navigate('/fundManagementInvestment/request', {
// //             state: {
// //               from: 'unitPurchase',
// //               to: data.subscriptionType,
// //               isAdmin: isAdmin
// //             }
// //           });

// //           setShowForm(false);
// //           setSelectedUnitClass(null);
// //           reset({
// //             investorName: loggedInUser.name,
// //             investorsEmailId: loggedInUser.email,
// //             investorAvatar: loggedInUser.avatar,
// //             calculationType: 'amount',
// //             purchaseUnits: 0,
// //             totalInvestmentAmt: 0,
// //             subscriptionType: 'incomeUnits'
// //           });
// //           dispatch(resetUnitsPurchaseStatus());
// //         }, 2000);
// //       } else {
// //         setSnackbar({
// //           open: true,
// //           message: (result.error as any)?.message || 'Purchase submission failed',
// //           severity: 'error'
// //         });
// //       }
// //     } catch (error) {
// //       console.error('Purchase submission failed:', error);
// //       setSnackbar({
// //         open: true,
// //         message: 'Purchase submission failed. Please try again.',
// //         severity: 'error'
// //       });
// //     }
// //   };

// //   React.useEffect(() => {
// //     if (purchaseStatus === 'succeeded' && lastTransaction) {
// //       setSnackbar({
// //         open: true,
// //         message: 'Purchase request submitted successfully!',
// //         severity: 'success'
// //       });

// //       setTimeout(() => {
// //         setShowForm(false);
// //         setSelectedUnitClass(null);
// //         reset({
// //           investorName: loggedInUser.name,
// //           investorsEmailId: loggedInUser.email,
// //           investorAvatar: loggedInUser.avatar,
// //           calculationType: 'amount',
// //           purchaseUnits: 0,
// //           totalInvestmentAmt: 0,
// //           subscriptionType: 'incomeUnits'
// //         });
// //         dispatch(resetUnitsPurchaseStatus());
// //       }, 3000);
// //     } else if (purchaseStatus === 'failed' && error) {
// //       setSnackbar({
// //         open: true,
// //         message: error,
// //         severity: 'error'
// //       });
// //     }
// //   }, [purchaseStatus, lastTransaction, error, reset, dispatch, loggedInUser]);

// //   const getRiskColor = (riskLevel: string) => {
// //     if (riskLevel.includes('Conservative')) return '#4caf50';
// //     if (riskLevel.includes('Moderate')) return '#ff9800';
// //     return '#f44336';
// //   };

// //   const getTotalCost = () => {
// //     return watchedValues.totalInvestmentAmt || 0;
// //   };

// //   const getDataSourceStatus = () => {
// //     if (loading || landingDataStatus === 'idle') {
// //       return { text: 'Loading fund data...', color: '#ff9800' };
// //     }

// //     if (landingDataStatus === 'failed') {
// //       return { text: 'Initial setup / Connection issue', color: '#f44336' };
// //     }

// //     if (landingDataStatus === 'succeeded') {
// //       const hasLiveData = unitClasses.some((unit) => unit.id.includes('live'));
// //       if (hasLiveData) {
// //         return { text: 'Live fund data', color: '#4caf50' };
// //       } else {
// //         return { text: 'Initial setup / First investor', color: '#2196f3' };
// //       }
// //     }

// //     return { text: 'Initial setup', color: '#2196f3' };
// //   };

// //   if (loading || landingDataStatus === 'idle') {
// //     return (
// //       <Container
// //         maxWidth="xl"
// //         sx={{
// //           padding: 3,
// //           display: 'flex',
// //           justifyContent: 'center',
// //           alignItems: 'center',
// //           minHeight: '50vh'
// //         }}
// //       >
// //         <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
// //           <CircularProgress size={40} />
// //           <Typography variant="body1" color="text.secondary">
// //             Loading unit class data...
// //           </Typography>
// //         </Box>
// //       </Container>
// //     );
// //   }

// //   const dataStatus = getDataSourceStatus();

// //   return (
// //     <Container
// //       maxWidth="xl"
// //       sx={{
// //         padding: { xs: 1, sm: 2, md: 3 },
// //         minHeight: '100vh'
// //       }}
// //     >
// //       {/* Header */}
// //       <Box
// //         sx={{
// //           display: 'flex',
// //           alignItems: 'center',
// //           marginBottom: { xs: 2, md: 3 },
// //           flexWrap: 'wrap',
// //           gap: { xs: 1, md: 0 }
// //         }}
// //       >
// //         <FaMoneyBillWave
// //           size={isMobile ? 20 : 24}
// //           color="#1976d2"
// //           style={{ marginRight: isMobile ? 8 : 12, flexShrink: 0 }}
// //         />
// //         <Box sx={{ flex: 1, minWidth: 0 }}>
// //           <Typography
// //             variant="h6"
// //             component="h1"
// //             sx={{
// //               fontWeight: 500,
// //               color: '#333',
// //               fontSize: { xs: '1rem', md: '1.2rem' }
// //             }}
// //           >
// //             Unit Purchase
// //           </Typography>
// //           <Typography
// //             variant="body2"
// //             sx={{
// //               color: '#666',
// //               marginTop: 0.5,
// //               fontSize: { xs: '0.75rem', md: '0.8rem' }
// //             }}
// //           >
// //             Select your preferred unit class and subscribe to our trust fund
// //             <span style={{ marginLeft: '8px', color: dataStatus.color }}>{dataStatus.text}</span>
// //           </Typography>
// //         </Box>
// //       </Box>

// //       {!showForm ? (
// //         <>
// //           <Typography
// //             variant="body1"
// //             sx={{
// //               fontWeight: 500,
// //               marginBottom: { xs: 2, md: 2.5 },
// //               color: '#333',
// //               fontSize: { xs: '0.9rem', md: '1rem' }
// //             }}
// //           >
// //             Choose Your Investment Strategy
// //           </Typography>
// //           <Grid container spacing={{ xs: 2, md: 4 }}>
// //             {unitClasses.map((unitClass) => (
// //               <Grid item xs={12} md={6} key={unitClass.id}>
// //                 <Card
// //                   sx={{
// //                     height: '100%',
// //                     cursor: 'pointer',
// //                     transition: 'all 0.3s ease',
// //                     borderRadius: { xs: 2, md: 3 },
// //                     border: '2px solid #e0e0e0',
// //                     position: 'relative',
// //                     overflow: 'hidden',
// //                     '&:hover': {
// //                       transform: 'translateY(-4px)',
// //                       boxShadow: '0 8px 20px rgba(0,0,0,0.15)',
// //                       border: '2px solid #1976d2'
// //                     }
// //                   }}
// //                   onClick={() => handleUnitClassSelect(unitClass)}
// //                 >
// //                   <Box
// //                     sx={{
// //                       background:
// //                         unitClass.type === 'Income'
// //                           ? 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)'
// //                           : 'linear-gradient(135deg, #fa709a 0%, #fee140 100%)',
// //                       padding: { xs: 2, md: 3 },
// //                       color: 'white'
// //                     }}
// //                   >
// //                     <Box
// //                       sx={{
// //                         display: 'flex',
// //                         justifyContent: 'space-between',
// //                         alignItems: 'center'
// //                       }}
// //                     >
// //                       <Box sx={{ flex: 1, minWidth: 0 }}>
// //                         <Box
// //                           sx={{ display: 'flex', alignItems: 'center', gap: 1, marginBottom: 1 }}
// //                         >
// //                           <Typography
// //                             variant="h6"
// //                             sx={{
// //                               fontWeight: 500,
// //                               fontSize: { xs: '0.95rem', md: '1.1rem' },
// //                               overflow: 'hidden',
// //                               textOverflow: 'ellipsis',
// //                               whiteSpace: 'nowrap'
// //                             }}
// //                           >
// //                             {unitClass.name}
// //                           </Typography>
// //                           <Chip
// //                             label={unitClass.id.includes('live') ? 'Live' : 'Initial'}
// //                             size="small"
// //                             sx={{
// //                               backgroundColor: unitClass.id.includes('live')
// //                                 ? 'rgba(76, 175, 80, 0.3)'
// //                                 : 'rgba(158, 158, 158, 0.3)',
// //                               color: 'white',
// //                               fontWeight: 500,
// //                               fontSize: '0.6rem',
// //                               height: 20
// //                             }}
// //                           />
// //                         </Box>
// //                         <Typography
// //                           variant="h6"
// //                           sx={{
// //                             fontWeight: 600,
// //                             fontSize: { xs: '1.1rem', md: '1.3rem' }
// //                           }}
// //                         >
// //                           {formatCurrency(unitClass.unitPrice)}
// //                         </Typography>
// //                         <Typography
// //                           variant="body2"
// //                           sx={{
// //                             opacity: 0.9,
// //                             fontSize: { xs: '0.7rem', md: '0.75rem' }
// //                           }}
// //                         >
// //                           per unit
// //                         </Typography>
// //                       </Box>
// //                       <Box sx={{ textAlign: 'center', flexShrink: 0, marginLeft: 1 }}>
// //                         {unitClass.type === 'Income' ? (
// //                           <FaPiggyBank size={isMobile ? 28 : 32} />
// //                         ) : (
// //                           <FaArrowUp size={isMobile ? 28 : 32} />
// //                         )}
// //                       </Box>
// //                     </Box>
// //                   </Box>

// //                   <CardContent sx={{ padding: { xs: 2, md: 3 } }}>
// //                     <Typography
// //                       variant="body1"
// //                       sx={{
// //                         marginBottom: 2,
// //                         color: '#666',
// //                         lineHeight: 1.6,
// //                         fontSize: { xs: '0.8rem', md: '0.85rem' }
// //                       }}
// //                     >
// //                       {unitClass.description}
// //                     </Typography>

// //                     <Grid container spacing={{ xs: 1, md: 2 }} sx={{ marginBottom: 3 }}>
// //                       <Grid item xs={6}>
// //                         <Box
// //                           sx={{
// //                             textAlign: 'center',
// //                             padding: { xs: 1.5, md: 2 },
// //                             backgroundColor: '#f5f5f5',
// //                             borderRadius: 2
// //                           }}
// //                         >
// //                           <Typography
// //                             variant="body1"
// //                             sx={{
// //                               fontWeight: 500,
// //                               color: '#333',
// //                               fontSize: { xs: '0.8rem', md: '0.9rem' }
// //                             }}
// //                           >
// //                             {unitClass.totalUnits.toLocaleString()}
// //                           </Typography>
// //                           <Typography
// //                             variant="caption"
// //                             sx={{
// //                               color: '#666',
// //                               fontSize: { xs: '0.65rem', md: '0.7rem' }
// //                             }}
// //                           >
// //                             Total Units
// //                           </Typography>
// //                         </Box>
// //                       </Grid>
// //                       <Grid item xs={6}>
// //                         <Box
// //                           sx={{
// //                             textAlign: 'center',
// //                             padding: { xs: 1.5, md: 2 },
// //                             backgroundColor: '#f5f5f5',
// //                             borderRadius: 2
// //                           }}
// //                         >
// //                           <Typography
// //                             variant="body1"
// //                             sx={{
// //                               fontWeight: 500,
// //                               color: '#333',
// //                               fontSize: { xs: '0.8rem', md: '0.9rem' },
// //                               overflow: 'hidden',
// //                               textOverflow: 'ellipsis',
// //                               whiteSpace: 'nowrap'
// //                             }}
// //                           >
// //                             {unitClass.totalNAV === 0
// //                               ? '0'
// //                               : isMobile
// //                               ? formatCurrency(unitClass.totalNAV).replace('$', '').slice(0, -3) +
// //                                 'K'
// //                               : formatCurrency(unitClass.totalNAV)}
// //                           </Typography>
// //                           <Typography
// //                             variant="caption"
// //                             sx={{
// //                               color: '#666',
// //                               fontSize: { xs: '0.65rem', md: '0.7rem' }
// //                             }}
// //                           >
// //                             Total NAV
// //                           </Typography>
// //                         </Box>
// //                       </Grid>
// //                     </Grid>

// //                     <Typography
// //                       variant="body2"
// //                       sx={{
// //                         fontWeight: 500,
// //                         marginBottom: 2,
// //                         color: '#333',
// //                         fontSize: { xs: '0.75rem', md: '0.8rem' }
// //                       }}
// //                     >
// //                       Key Features
// //                     </Typography>
// //                     <Box sx={{ marginBottom: 3 }}>
// //                       {unitClass.features.map((feature, index) => (
// //                         <Typography
// //                           key={index}
// //                           variant="body2"
// //                           sx={{
// //                             color: '#666',
// //                             marginBottom: 0.5,
// //                             fontSize: { xs: '0.7rem', md: '0.75rem' }
// //                           }}
// //                         >
// //                           {feature}
// //                         </Typography>
// //                       ))}
// //                     </Box>

// //                     <Box
// //                       sx={{
// //                         display: 'flex',
// //                         justifyContent: 'space-between',
// //                         alignItems: 'center',
// //                         marginBottom: 2,
// //                         flexWrap: 'wrap',
// //                         gap: 1
// //                       }}
// //                     >
// //                       <Chip
// //                         label={`Risk: ${unitClass.riskLevel}`}
// //                         size="small"
// //                         sx={{
// //                           backgroundColor: getRiskColor(unitClass.riskLevel),
// //                           color: 'white',
// //                           fontWeight: 500,
// //                           fontSize: { xs: '0.6rem', md: '0.65rem' }
// //                         }}
// //                       />
// //                       <Typography
// //                         variant="body2"
// //                         sx={{
// //                           color: '#666',
// //                           fontSize: { xs: '0.7rem', md: '0.75rem' }
// //                         }}
// //                       >
// //                         Min: {formatCurrency(unitClass.minimumInvestment)}
// //                       </Typography>
// //                     </Box>

// //                     <Button
// //                       fullWidth
// //                       variant="contained"
// //                       endIcon={<FaArrowRight />}
// //                       disabled={Boolean(loading)}
// //                       sx={{
// //                         backgroundColor: '#1976d2',
// //                         '&:hover': { backgroundColor: '#1565c0' },
// //                         textTransform: 'none',
// //                         fontWeight: 500,
// //                         borderRadius: 2,
// //                         padding: { xs: '10px', md: '12px' },
// //                         fontSize: { xs: '0.8rem', md: '0.85rem' }
// //                       }}
// //                     >
// //                       Subscribe to {unitClass.name}
// //                     </Button>
// //                   </CardContent>
// //                 </Card>
// //               </Grid>
// //             ))}
// //           </Grid>
// //         </>
// //       ) : (
// //         <form onSubmit={handleSubmit(onSubmit)}>
// //           <Grid container spacing={{ xs: 2, md: 4 }}>
// //             {/* Summary Panel */}
// //             <Grid item xs={12} md={4}>
// //               <Paper
// //                 sx={{
// //                   padding: { xs: 2, md: 3 },
// //                   borderRadius: 3,
// //                   position: { xs: 'static', md: 'sticky' },
// //                   top: 150,
// //                   height: 'fit-content'
// //                 }}
// //               >
// //                 <Typography
// //                   variant="body1"
// //                   sx={{
// //                     fontWeight: 500,
// //                     marginBottom: 2,
// //                     display: 'flex',
// //                     alignItems: 'center',
// //                     fontSize: { xs: '0.85rem', md: '0.9rem' }
// //                   }}
// //                 >
// //                   <FaCoins size={isMobile ? 14 : 16} color="#1976d2" style={{ marginRight: 8 }} />
// //                   Selected Unit Class
// //                 </Typography>

// //                 <Button
// //                   fullWidth
// //                   variant="outlined"
// //                   startIcon={<TbArrowsExchange />}
// //                   onClick={() => setShowForm(false)}
// //                   disabled={Boolean(loading)}
// //                   sx={{
// //                     textTransform: 'none',
// //                     marginBottom: 2,
// //                     fontSize: { xs: '0.75rem', md: '0.8rem' },
// //                     fontWeight: 500,
// //                     borderRadius: 2
// //                   }}
// //                 >
// //                   Change Unit Class
// //                 </Button>

// //                 <Box
// //                   sx={{
// //                     background:
// //                       selectedUnitClass?.type === 'Income'
// //                         ? 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)'
// //                         : 'linear-gradient(135deg, #fa709a 0%, #fee140 100%)',
// //                     padding: { xs: 1.5, md: 2 },
// //                     borderRadius: 2,
// //                     color: 'white',
// //                     marginBottom: 3
// //                   }}
// //                 >
// //                   <Typography variant="body1" sx={{ fontWeight: 500, marginBottom: 1 }}>
// //                     {selectedUnitClass?.name}
// //                   </Typography>
// //                   <Typography variant="h6" sx={{ fontWeight: 600 }}>
// //                     {formatCurrency(selectedUnitClass?.unitPrice || 0)}
// //                   </Typography>
// //                   <Typography variant="body2" sx={{ opacity: 0.9 }}>
// //                     per unit
// //                   </Typography>
// //                 </Box>

// //                 <Divider sx={{ marginY: 2 }} />

// //                 <Typography variant="body2" sx={{ fontWeight: 500, marginBottom: 2 }}>
// //                   Investment Summary
// //                 </Typography>

// //                 <Box sx={{ marginBottom: 2 }}>
// //                   <Box sx={{ display: 'flex', justifyContent: 'space-between', marginBottom: 1 }}>
// //                     <Typography variant="body2" sx={{ color: '#666' }}>
// //                       Units
// //                     </Typography>
// //                     <Typography variant="body2" sx={{ fontWeight: 500 }}>
// //                       {watchedValues.purchaseUnits?.toFixed(2) || '0.00'}
// //                     </Typography>
// //                   </Box>

// //                   <Box sx={{ display: 'flex', justifyContent: 'space-between', marginBottom: 1 }}>
// //                     <Typography variant="body2" sx={{ color: '#666' }}>
// //                       Unit Price
// //                     </Typography>
// //                     <Typography variant="body2" sx={{ fontWeight: 500 }}>
// //                       {formatCurrency(selectedUnitClass?.unitPrice || 0)}
// //                     </Typography>
// //                   </Box>

// //                   <Divider sx={{ marginY: 1 }} />

// //                   <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
// //                     <Typography variant="body2" sx={{ fontWeight: 500 }}>
// //                       Base Amount
// //                     </Typography>
// //                     <Typography variant="body2" sx={{ fontWeight: 600, color: '#1976d2' }}>
// //                       {formatCurrency(getTotalCost())}
// //                     </Typography>
// //                   </Box>
// //                 </Box>

// //                 {/* Dynamic Operational Fee from API */}
// //                 <Box
// //                   sx={{
// //                     marginBottom: 2,
// //                     padding: '12px',
// //                     backgroundColor: '#f0f7ff',
// //                     borderRadius: 2
// //                   }}
// //                 >
// //                   {feeLoadingStatus === 'loading' ? (
// //                     <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
// //                       <CircularProgress size={16} />
// //                       <Typography variant="body2" sx={{ color: '#999', fontSize: '0.8rem' }}>
// //                         Loading fee configuration...
// //                       </Typography>
// //                     </Box>
// //                   ) : feeLoadingStatus === 'error' ? (
// //                     <Alert severity="warning" sx={{ padding: '4px 8px', fontSize: '0.75rem' }}>
// //                       Unable to load operational fee
// //                     </Alert>
// //                   ) : (
// //                     <>
// //                       <Typography
// //                         variant="body2"
// //                         color="textSecondary"
// //                         sx={{ fontWeight: 'medium', marginBottom: 0.5, fontSize: '0.8rem' }}
// //                       >
// //                         Operational Fee ({operationPercentage}%): {formatCurrency(operationCharge)}
// //                       </Typography>
// //                       <Typography
// //                         variant="body1"
// //                         sx={{
// //                           fontWeight: 'bold',
// //                           marginTop: 0.5,
// //                           color: '#1976d2',
// //                           fontSize: { xs: '0.85rem', md: '0.9rem' }
// //                         }}
// //                       >
// //                         Total with Fee: {formatCurrency(totalWithFee)}
// //                       </Typography>
// //                     </>
// //                   )}
// //                 </Box>

// //                 {/* Capacity Section */}
// //                 <Divider sx={{ marginY: 2 }} />
// //                 <Typography variant="body2" sx={{ fontWeight: 500, marginBottom: 2 }}>
// //                   Investment Capacity
// //                 </Typography>

// //                 {capacityLoading ? (
// //                   <Box sx={{ display: 'flex', justifyContent: 'center', padding: 1 }}>
// //                     <CircularProgress size={20} />
// //                   </Box>
// //                 ) : capacitySummary ? (
// //                   <Box
// //                     sx={{
// //                       padding: 1.5,
// //                       backgroundColor: checkCapacitySufficient(totalWithFee)
// //                         ? '#e8f5e9'
// //                         : '#ffebee',
// //                       borderRadius: 2,
// //                       border: `1px solid ${
// //                         checkCapacitySufficient(totalWithFee) ? '#4caf50' : '#f44336'
// //                       }`,
// //                       marginBottom: 2
// //                     }}
// //                   >
// //                     <Box sx={{ display: 'flex', justifyContent: 'space-between', marginBottom: 1 }}>
// //                       <Typography variant="body2" sx={{ color: '#666' }}>
// //                         Available
// //                       </Typography>
// //                       <Typography
// //                         variant="body2"
// //                         sx={{
// //                           fontWeight: 600,
// //                           color: checkCapacitySufficient(totalWithFee) ? '#2e7d32' : '#c62828'
// //                         }}
// //                       >
// //                         {formatCurrency(capacitySummary.my_capacity || 0)}
// //                       </Typography>
// //                     </Box>

// //                     <Box sx={{ display: 'flex', justifyContent: 'space-between', marginBottom: 1 }}>
// //                       <Typography variant="body2" sx={{ color: '#666' }}>
// //                         Requesting
// //                       </Typography>
// //                       <Typography variant="body2" sx={{ fontWeight: 500 }}>
// //                         {formatCurrency(totalWithFee)}
// //                       </Typography>
// //                     </Box>

// //                     <Divider sx={{ marginY: 1 }} />

// //                     <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
// //                       <Typography variant="body2" sx={{ fontWeight: 500 }}>
// //                         After Purchase
// //                       </Typography>
// //                       <Typography
// //                         variant="body2"
// //                         sx={{
// //                           fontWeight: 600,
// //                           color: checkCapacitySufficient(totalWithFee) ? '#1976d2' : '#c62828'
// //                         }}
// //                       >
// //                         {formatCurrency(getCapacityAfterPurchase(totalWithFee))}
// //                       </Typography>
// //                     </Box>

// //                     {!checkCapacitySufficient(totalWithFee) && totalWithFee > 0 && (
// //                       <Alert
// //                         severity="error"
// //                         sx={{ marginTop: 1.5, padding: '4px 8px', fontSize: '0.75rem' }}
// //                       >
// //                         Insufficient capacity! Reduce amount or increase capacity.
// //                       </Alert>
// //                     )}
// //                   </Box>
// //                 ) : (
// //                   <Alert severity="warning" sx={{ padding: '4px 8px', fontSize: '0.75rem' }}>
// //                     Unable to load capacity data.
// //                   </Alert>
// //                 )}
// //               </Paper>
// //             </Grid>

// //             {/* Form Panel */}
// //             <Grid item xs={12} md={8}>
// //               <Paper sx={{ padding: { xs: 2, md: 4 }, borderRadius: 3 }}>
// //                 <Typography
// //                   variant="body1"
// //                   sx={{
// //                     fontWeight: 500,
// //                     marginBottom: 2,
// //                     display: 'flex',
// //                     alignItems: 'center'
// //                   }}
// //                 >
// //                   <MdPerson size={18} color="#1976d2" style={{ marginRight: 8 }} />
// //                   Current Investor
// //                 </Typography>

// //                 <Box
// //                   sx={{
// //                     display: 'flex',
// //                     alignItems: 'center',
// //                     padding: 2,
// //                     backgroundColor: '#e3f2fd',
// //                     borderRadius: 2,
// //                     border: '1px solid #1976d2',
// //                     marginBottom: 3
// //                   }}
// //                 >
// //                   <Avatar
// //                     src={loggedUserAvatarUrl || undefined}
// //                     sx={{ width: 48, height: 48, marginRight: 2 }}
// //                   >
// //                     {watchedValues.investorName?.charAt(0) || 'U'}
// //                   </Avatar>
// //                   <Box sx={{ flex: 1 }}>
// //                     <Typography variant="body1" sx={{ fontWeight: 500 }}>
// //                       {watchedValues.investorName}
// //                     </Typography>
// //                     <Typography variant="body2" sx={{ color: '#666' }}>
// //                       {watchedValues.investorsEmailId}
// //                     </Typography>
// //                   </Box>
// //                   <Button variant="outlined" size="small" onClick={handleSelectSelf}>
// //                     Reset to Self
// //                   </Button>
// //                 </Box>

// //                 {/* Hidden fields */}
// //                 <Controller
// //                   name="investorName"
// //                   control={control}
// //                   render={({ field }) => <input type="hidden" {...field} />}
// //                 />
// //                 <Controller
// //                   name="investorsEmailId"
// //                   control={control}
// //                   render={({ field }) => <input type="hidden" {...field} />}
// //                 />
// //                 <Controller
// //                   name="investorAvatar"
// //                   control={control}
// //                   render={({ field }) => <input type="hidden" {...field} />}
// //                 />

// //                 <Divider sx={{ marginY: 3 }} />

// //                 <Typography
// //                   variant="body1"
// //                   sx={{
// //                     fontWeight: 500,
// //                     marginBottom: 2,
// //                     display: 'flex',
// //                     alignItems: 'center'
// //                   }}
// //                 >
// //                   <FaCalculator size={16} color="#1976d2" style={{ marginRight: 8 }} />
// //                   Investment Calculation
// //                 </Typography>

// //                 <Grid container spacing={2}>
// //                   <Grid item xs={12}>
// //                     <Controller
// //                       name="calculationType"
// //                       control={control}
// //                       render={({ field: { onChange, value } }) => (
// //                         <FormControl component="fieldset">
// //                           <FormLabel component="legend">Calculate by</FormLabel>
// //                           <RadioGroup
// //                             row
// //                             value={value}
// //                             onChange={(e) => {
// //                               const newValue = e.target.value as 'amount' | 'units';
// //                               onChange(newValue);
// //                               handleCalculationTypeChange(newValue);
// //                             }}
// //                           >
// //                             <FormControlLabel
// //                               value="amount"
// //                               control={<Radio />}
// //                               label="Investment Amount"
// //                             />
// //                             <FormControlLabel
// //                               value="units"
// //                               control={<Radio />}
// //                               label="Number of Units"
// //                             />
// //                           </RadioGroup>
// //                         </FormControl>
// //                       )}
// //                     />
// //                   </Grid>

// //                   {watchedValues.calculationType === 'amount' ? (
// //                     <>
// //                       <Grid item xs={12} sm={6}>
// //                         <Controller
// //                           name="totalInvestmentAmt"
// //                           control={control}
// //                           render={({ field }) => (
// //                             <TextField
// //                               {...field}
// //                               fullWidth
// //                               label="Investment Amount"
// //                               type="number"
// //                               error={!!errors.totalInvestmentAmt}
// //                               helperText={
// //                                 errors.totalInvestmentAmt?.message ||
// //                                 `Minimum ${formatCurrency(
// //                                   selectedUnitClass?.minimumInvestment || 0
// //                                 )}`
// //                               }
// //                               InputProps={{
// //                                 startAdornment: (
// //                                   <InputAdornment position="start">AUD</InputAdornment>
// //                                 )
// //                               }}
// //                               onChange={(e) => {
// //                                 const value = parseFloat(e.target.value) || 0;
// //                                 field.onChange(value);
// //                                 handleAmountChange(value);
// //                               }}
// //                             />
// //                           )}
// //                         />
// //                       </Grid>
// //                       <Grid item xs={12} sm={6}>
// //                         <Controller
// //                           name="purchaseUnits"
// //                           control={control}
// //                           render={({ field }) => (
// //                             <TextField
// //                               {...field}
// //                               fullWidth
// //                               label="Number of Units"
// //                               type="number"
// //                               error={!!errors.purchaseUnits}
// //                               helperText={errors.purchaseUnits?.message || 'Units can be decimal'}
// //                               inputProps={{ step: 0.01 }}
// //                               onChange={(e) => {
// //                                 const value = parseFloat(e.target.value) || 0;
// //                                 field.onChange(value);
// //                                 handleUnitsChange(value);
// //                               }}
// //                             />
// //                           )}
// //                         />
// //                       </Grid>
// //                     </>
// //                   ) : (
// //                     <>
// //                       <Grid item xs={12} sm={6}>
// //                         <Controller
// //                           name="purchaseUnits"
// //                           control={control}
// //                           render={({ field }) => (
// //                             <TextField
// //                               {...field}
// //                               fullWidth
// //                               label="Number of Units"
// //                               type="number"
// //                               error={!!errors.purchaseUnits}
// //                               helperText={errors.purchaseUnits?.message}
// //                               inputProps={{ step: 0.01 }}
// //                               onChange={(e) => {
// //                                 const value = parseFloat(e.target.value) || 0;
// //                                 field.onChange(value);
// //                                 handleUnitsChange(value);
// //                               }}
// //                             />
// //                           )}
// //                         />
// //                       </Grid>
// //                       <Grid item xs={12} sm={6}>
// //                         <TextField
// //                           fullWidth
// //                           label="Calculated Amount"
// //                           value={formatCurrency(watchedValues.totalInvestmentAmt || 0)}
// //                           disabled
// //                         />
// //                       </Grid>
// //                     </>
// //                   )}

// //                   <Grid item xs={12}>
// //                     <Box sx={{ marginTop: 3, textAlign: 'center' }}>
// //                       <Alert severity="info" sx={{ marginBottom: 3 }}>
// //                         Purchase request will be reviewed by the fund manager.
// //                       </Alert>

// //                       {capacitySummary &&
// //                         !checkCapacitySufficient(totalWithFee) &&
// //                         totalWithFee > 0 && (
// //                           <Alert
// //                             severity="error"
// //                             icon={<CancelIcon />}
// //                             sx={{ marginBottom: 3, backgroundColor: '#ffebee' }}
// //                           >
// //                             <Typography variant="h6" sx={{ fontWeight: 600, color: '#c62828' }}>
// //                               Insufficient Funds
// //                             </Typography>
// //                             <Typography variant="body2" sx={{ marginTop: 1 }}>
// //                               Available: {formatCurrency(capacitySummary.my_capacity || 0)} |
// //                               Requesting: {formatCurrency(totalWithFee)} | Shortfall:{' '}
// //                               {formatCurrency(Math.abs(getCapacityAfterPurchase(totalWithFee)))}
// //                             </Typography>
// //                           </Alert>
// //                         )}

// //                       <Button
// //                         type="submit"
// //                         variant="contained"
// //                         size="large"
// //                         disabled={
// //                           !isValid ||
// //                           Boolean(loading) ||
// //                           !capacitySummary ||
// //                           !checkCapacitySufficient(totalWithFee)
// //                         }
// //                         startIcon={loading ? <CircularProgress size={20} /> : null}
// //                         sx={{
// //                           textTransform: 'none',
// //                           fontWeight: 500,
// //                           borderRadius: 2,
// //                           padding: '12px 36px'
// //                         }}
// //                       >
// //                         {loading
// //                           ? 'Submitting...'
// //                           : !capacitySummary
// //                           ? 'Loading...'
// //                           : !checkCapacitySufficient(totalWithFee)
// //                           ? `Need ${formatCurrency(totalWithFee - getRemainingCapacity())} More`
// //                           : 'Submit Purchase Request'}
// //                       </Button>
// //                     </Box>
// //                   </Grid>
// //                 </Grid>
// //               </Paper>
// //             </Grid>
// //           </Grid>
// //         </form>
// //       )}

// //       <Snackbar
// //         open={snackbar.open}
// //         autoHideDuration={6000}
// //         onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
// //         anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
// //       >
// //         <Alert
// //           onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
// //           severity={snackbar.severity}
// //           sx={{ width: '100%', borderRadius: 2 }}
// //         >
// //           {snackbar.message}
// //         </Alert>
// //       </Snackbar>
// //     </Container>
// //   );
// // };

// // export default UnitPurchase;



// import {
//   Alert,
//   Avatar,
//   Box,
//   Button,
//   Card,
//   CardContent,
//   Chip,
//   CircularProgress,
//   Container,
//   Divider,
//   FormControl,
//   FormControlLabel,
//   FormLabel,
//   Grid,
//   InputAdornment,
//   Paper,
//   Radio,
//   RadioGroup,
//   Snackbar,
//   TextField,
//   Typography
// } from '@mui/material';
// import React from 'react';
// import { Controller } from 'react-hook-form';
// import {
//   FaArrowRight,
//   FaArrowUp,
//   FaCalculator,
//   FaCoins,
//   FaMoneyBillWave,
//   FaPiggyBank,
//   FaShoppingCart
// } from 'react-icons/fa';
// import { MdCancel as CancelIcon, MdPerson } from 'react-icons/md';
// import { TbArrowsExchange } from 'react-icons/tb';
// import { useUnitPurchaseLogic } from './UnitPurchaseLogic';
// import { formatCurrency, getRiskColor } from './UnitPurchaseUtils';
// import { UnitClass, SnackbarState } from './UnitPurchaseTypes';
// import CertificateViewer from '../certificate/CertificateViewer';

// const UnitPurchase: React.FC = () => {
//   const {
//     unitClasses,
//     selectedUnitClass,
//     showForm,
//     loading,
//     landingDataStatus,
//     capacitySummary,
//     capacityLoading,
//     loggedInUser,
//     loggedUserAvatarUrl,
//     snackbar,
//     feeLoadingStatus,
//     isMobile,
//     marketplaceData,
//     control,
//     handleSubmit,
//     watchedValues,
//     errors,
//     isValid,
//     setValue,
//     operationPercentage,
//     operationCharge,
//     totalWithFee,
//     setShowForm,
//     setSnackbar,
//     handleUnitClassSelect,
//     handleSelectSelf,
//     handleCalculationTypeChange,
//     handleAmountChange,
//     handleUnitsChange,
//     onSubmit,
//     checkCapacitySufficient,
//     getRemainingCapacity,
//     getCapacityAfterPurchase,
//     getTotalCost,
//     getDataSourceStatus,
//     // Added for certificate modal
//     showCertificateModal,
//     certificatePayload,
//     handleCertificateClose
//   } = useUnitPurchaseLogic();

//   // ==================== LOADING STATE ====================
//   if (loading || landingDataStatus === 'idle') {
//     return (
//       <Container
//         maxWidth="xl"
//         sx={{
//           padding: 3,
//           display: 'flex',
//           justifyContent: 'center',
//           alignItems: 'center',
//           minHeight: '50vh'
//         }}
//       >
//         <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
//           <CircularProgress size={40} />
//           <Typography variant="body1" color="text.secondary">
//             Loading unit class data...
//           </Typography>
//         </Box>
//       </Container>
//     );
//   }

//   const dataStatus = getDataSourceStatus();

//   return (
//     <Container
//       maxWidth="xl"
//       sx={{
//         padding: { xs: 1, sm: 2, md: 3 },
//         minHeight: '100vh'
//       }}
//     >
//       {/* ==================== HEADER ==================== */}
//       <Box
//         sx={{
//           display: 'flex',
//           alignItems: 'center',
//           marginBottom: { xs: 2, md: 3 },
//           flexWrap: 'wrap',
//           gap: { xs: 1, md: 0 }
//         }}
//       >
//         <FaMoneyBillWave
//           size={isMobile ? 20 : 24}
//           color="#1976d2"
//           style={{ marginRight: isMobile ? 8 : 12, flexShrink: 0 }}
//         />
//         <Box sx={{ flex: 1, minWidth: 0 }}>
//           <Typography
//             variant="h6"
//             component="h1"
//             sx={{
//               fontWeight: 500,
//               color: '#333',
//               fontSize: { xs: '1rem', md: '1.2rem' }
//             }}
//           >
//             Unit Purchase
//           </Typography>
//           <Typography
//             variant="body2"
//             sx={{
//               color: '#666',
//               marginTop: 0.5,
//               fontSize: { xs: '0.75rem', md: '0.8rem' }
//             }}
//           >
//             Select your preferred unit class and subscribe to our trust fund
//             <span style={{ marginLeft: '8px', color: dataStatus.color }}>{dataStatus.text}</span>
//           </Typography>
//         </Box>
//       </Box>

//       {/* ==================== MARKETPLACE ALERT ==================== */}
//       {marketplaceData && (
//         <Alert
//           severity="info"
//           icon={<FaShoppingCart size={20} />}
//           sx={{
//             marginBottom: 3,
//             borderRadius: 2,
//             border: '2px solid #1976d2'
//           }}
//         >
//           <Typography variant="body1" sx={{ fontWeight: 600, marginBottom: 1, fontSize: '0.9rem' }}>
//             Buying from Marketplace
//           </Typography>
//           <Typography variant="body2" sx={{ marginBottom: 1, fontSize: '0.85rem' }}>
//             You are purchasing <strong>{marketplaceData.sellUnits} units</strong> from{' '}
//             <strong>{marketplaceData.sellerName}</strong>
//           </Typography>
//           <Box sx={{ display: 'flex', gap: 2, marginTop: 1, flexWrap: 'wrap' }}>
//             <Chip
//               size="small"
//               label={`Unit Price: ${formatCurrency(marketplaceData.unitPrice)}`}
//               sx={{ fontSize: '0.75rem' }}
//             />
//             <Chip
//               size="small"
//               label={`Total: ${formatCurrency(
//                 marketplaceData.sellUnits * marketplaceData.unitPrice
//               )}`}
//               color="primary"
//               sx={{ fontSize: '0.75rem' }}
//             />
//             <Chip
//               size="small"
//               label={
//                 marketplaceData.subscriptionType === 'incomeUnits' ? 'Income Units' : 'Growth Units'
//               }
//               color="secondary"
//               sx={{ fontSize: '0.75rem' }}
//             />
//           </Box>
//         </Alert>
//       )}

//       {/* ==================== UNIT CLASS SELECTION ==================== */}
//       {!showForm ? (
//         <>
//           <Typography
//             variant="body1"
//             sx={{
//               fontWeight: 500,
//               marginBottom: { xs: 2, md: 2.5 },
//               color: '#333',
//               fontSize: { xs: '0.9rem', md: '1rem' }
//             }}
//           >
//             Choose Your Investment Strategy
//           </Typography>
//           <Grid container spacing={{ xs: 2, md: 4 }}>
//             {unitClasses.map((unitClass: UnitClass) => (
//               <Grid item xs={12} md={6} key={unitClass.id}>
//                 <Card
//                   sx={{
//                     height: '100%',
//                     cursor: 'pointer',
//                     transition: 'all 0.3s ease',
//                     borderRadius: { xs: 2, md: 3 },
//                     border: '2px solid #e0e0e0',
//                     position: 'relative',
//                     overflow: 'hidden',
//                     '&:hover': {
//                       transform: 'translateY(-4px)',
//                       boxShadow: '0 8px 20px rgba(0,0,0,0.15)',
//                       border: '2px solid #1976d2'
//                     }
//                   }}
//                   onClick={() => handleUnitClassSelect(unitClass)}
//                 >
//                   {/* Card Header */}
//                   <Box
//                     sx={{
//                       background:
//                         unitClass.type === 'Income'
//                           ? 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)'
//                           : 'linear-gradient(135deg, #fa709a 0%, #fee140 100%)',
//                       padding: { xs: 2, md: 3 },
//                       color: 'white'
//                     }}
//                   >
//                     <Box
//                       sx={{
//                         display: 'flex',
//                         justifyContent: 'space-between',
//                         alignItems: 'center'
//                       }}
//                     >
//                       <Box sx={{ flex: 1, minWidth: 0 }}>
//                         <Box
//                           sx={{ display: 'flex', alignItems: 'center', gap: 1, marginBottom: 1 }}
//                         >
//                           <Typography
//                             variant="h6"
//                             sx={{
//                               fontWeight: 500,
//                               fontSize: { xs: '0.95rem', md: '1.1rem' },
//                               overflow: 'hidden',
//                               textOverflow: 'ellipsis',
//                               whiteSpace: 'nowrap'
//                             }}
//                           >
//                             {unitClass.name}
//                           </Typography>
//                           <Chip
//                             label={unitClass.id.includes('live') ? 'Live' : 'Initial'}
//                             size="small"
//                             sx={{
//                               backgroundColor: unitClass.id.includes('live')
//                                 ? 'rgba(76, 175, 80, 0.3)'
//                                 : 'rgba(158, 158, 158, 0.3)',
//                               color: 'white',
//                               fontWeight: 500,
//                               fontSize: '0.6rem',
//                               height: 20
//                             }}
//                           />
//                         </Box>
//                         <Typography
//                           variant="h6"
//                           sx={{
//                             fontWeight: 600,
//                             fontSize: { xs: '1.1rem', md: '1.3rem' }
//                           }}
//                         >
//                           {formatCurrency(unitClass.unitPrice)}
//                         </Typography>
//                         <Typography
//                           variant="body2"
//                           sx={{
//                             opacity: 0.9,
//                             fontSize: { xs: '0.7rem', md: '0.75rem' }
//                           }}
//                         >
//                           per unit
//                         </Typography>
//                       </Box>
//                       <Box sx={{ textAlign: 'center', flexShrink: 0, marginLeft: 1 }}>
//                         {unitClass.type === 'Income' ? (
//                           <FaPiggyBank size={isMobile ? 28 : 32} />
//                         ) : (
//                           <FaArrowUp size={isMobile ? 28 : 32} />
//                         )}
//                       </Box>
//                     </Box>
//                   </Box>

//                   {/* Card Content */}
//                   <CardContent sx={{ padding: { xs: 2, md: 3 } }}>
//                     <Typography
//                       variant="body1"
//                       sx={{
//                         marginBottom: 2,
//                         color: '#666',
//                         lineHeight: 1.6,
//                         fontSize: { xs: '0.8rem', md: '0.85rem' }
//                       }}
//                     >
//                       {unitClass.description}
//                     </Typography>

//                     {/* Stats */}
//                     <Grid container spacing={{ xs: 1, md: 2 }} sx={{ marginBottom: 3 }}>
//                       <Grid item xs={6}>
//                         <Box
//                           sx={{
//                             textAlign: 'center',
//                             padding: { xs: 1.5, md: 2 },
//                             backgroundColor: '#f5f5f5',
//                             borderRadius: 2
//                           }}
//                         >
//                           <Typography
//                             variant="body1"
//                             sx={{
//                               fontWeight: 500,
//                               color: '#333',
//                               fontSize: { xs: '0.8rem', md: '0.9rem' }
//                             }}
//                           >
//                             {unitClass.totalUnits.toLocaleString()}
//                           </Typography>
//                           <Typography
//                             variant="caption"
//                             sx={{
//                               color: '#666',
//                               fontSize: { xs: '0.65rem', md: '0.7rem' }
//                             }}
//                           >
//                             Total Units
//                           </Typography>
//                         </Box>
//                       </Grid>
//                       <Grid item xs={6}>
//                         <Box
//                           sx={{
//                             textAlign: 'center',
//                             padding: { xs: 1.5, md: 2 },
//                             backgroundColor: '#f5f5f5',
//                             borderRadius: 2
//                           }}
//                         >
//                           <Typography
//                             variant="body1"
//                             sx={{
//                               fontWeight: 500,
//                               color: '#333',
//                               fontSize: { xs: '0.8rem', md: '0.9rem' },
//                               overflow: 'hidden',
//                               textOverflow: 'ellipsis',
//                               whiteSpace: 'nowrap'
//                             }}
//                           >
//                             {unitClass.totalNAV === 0
//                               ? '0'
//                               : isMobile
//                               ? formatCurrency(unitClass.totalNAV).replace('$', '').slice(0, -3) +
//                                 'K'
//                               : formatCurrency(unitClass.totalNAV)}
//                           </Typography>
//                           <Typography
//                             variant="caption"
//                             sx={{
//                               color: '#666',
//                               fontSize: { xs: '0.65rem', md: '0.7rem' }
//                             }}
//                           >
//                             Total NAV
//                           </Typography>
//                         </Box>
//                       </Grid>
//                     </Grid>

//                     {/* Features */}
//                     <Typography
//                       variant="body2"
//                       sx={{
//                         fontWeight: 500,
//                         marginBottom: 2,
//                         color: '#333',
//                         fontSize: { xs: '0.75rem', md: '0.8rem' }
//                       }}
//                     >
//                       Key Features
//                     </Typography>
//                     <Box sx={{ marginBottom: 3 }}>
//                       {unitClass.features.map((feature: string, index: number) => (
//                         <Typography
//                           key={index}
//                           variant="body2"
//                           sx={{
//                             color: '#666',
//                             marginBottom: 0.5,
//                             fontSize: { xs: '0.7rem', md: '0.75rem' }
//                           }}
//                         >
//                           • {feature}
//                         </Typography>
//                       ))}
//                     </Box>

//                     {/* Footer */}
//                     <Box
//                       sx={{
//                         display: 'flex',
//                         justifyContent: 'space-between',
//                         alignItems: 'center',
//                         marginBottom: 2,
//                         flexWrap: 'wrap',
//                         gap: 1
//                       }}
//                     >
//                       <Chip
//                         label={`Risk: ${unitClass.riskLevel}`}
//                         size="small"
//                         sx={{
//                           backgroundColor: getRiskColor(unitClass.riskLevel),
//                           color: 'white',
//                           fontWeight: 500,
//                           fontSize: { xs: '0.6rem', md: '0.65rem' }
//                         }}
//                       />
//                       <Typography
//                         variant="body2"
//                         sx={{
//                           color: '#666',
//                           fontSize: { xs: '0.7rem', md: '0.75rem' }
//                         }}
//                       >
//                         Min: {formatCurrency(unitClass.minimumInvestment)}
//                       </Typography>
//                     </Box>

//                     <Button
//                       fullWidth
//                       variant="contained"
//                       endIcon={<FaArrowRight />}
//                       disabled={Boolean(loading)}
//                       sx={{
//                         backgroundColor: '#1976d2',
//                         '&:hover': { backgroundColor: '#1565c0' },
//                         textTransform: 'none',
//                         fontWeight: 500,
//                         borderRadius: 2,
//                         padding: { xs: '10px', md: '12px' },
//                         fontSize: { xs: '0.8rem', md: '0.85rem' }
//                       }}
//                     >
//                       Subscribe to {unitClass.name}
//                     </Button>
//                   </CardContent>
//                 </Card>
//               </Grid>
//             ))}
//           </Grid>
//         </>
//       ) : (
//         /* ==================== PURCHASE FORM ==================== */
//         <form onSubmit={handleSubmit(onSubmit)}>
//           <Grid container spacing={{ xs: 2, md: 4 }}>
//             {/* Summary Panel */}
//             <Grid item xs={12} md={4}>
//               <Paper
//                 sx={{
//                   padding: { xs: 2, md: 3 },
//                   borderRadius: 3,
//                   position: { xs: 'static', md: 'sticky' },
//                   top: 150,
//                   height: 'fit-content'
//                 }}
//               >
//                 <Typography
//                   variant="body1"
//                   sx={{
//                     fontWeight: 500,
//                     marginBottom: 2,
//                     display: 'flex',
//                     alignItems: 'center',
//                     fontSize: { xs: '0.85rem', md: '0.9rem' }
//                   }}
//                 >
//                   <FaCoins size={isMobile ? 14 : 16} color="#1976d2" style={{ marginRight: 8 }} />
//                   Selected Unit Class
//                 </Typography>

//                 {!marketplaceData && (
//                   <Button
//                     fullWidth
//                     variant="outlined"
//                     startIcon={<TbArrowsExchange />}
//                     onClick={() => setShowForm(false)}
//                     disabled={Boolean(loading)}
//                     sx={{
//                       textTransform: 'none',
//                       marginBottom: 2,
//                       fontSize: { xs: '0.75rem', md: '0.8rem' },
//                       fontWeight: 500,
//                       borderRadius: 2
//                     }}
//                   >
//                     Change Unit Class
//                   </Button>
//                 )}

//                 <Box
//                   sx={{
//                     background:
//                       selectedUnitClass?.type === 'Income'
//                         ? 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)'
//                         : 'linear-gradient(135deg, #fa709a 0%, #fee140 100%)',
//                     padding: { xs: 1.5, md: 2 },
//                     borderRadius: 2,
//                     color: 'white',
//                     marginBottom: 3
//                   }}
//                 >
//                   <Typography variant="body1" sx={{ fontWeight: 500, marginBottom: 1 }}>
//                     {selectedUnitClass?.name}
//                   </Typography>
//                   <Typography variant="h6" sx={{ fontWeight: 600 }}>
//                     {formatCurrency(selectedUnitClass?.unitPrice || 0)}
//                   </Typography>
//                   <Typography variant="body2" sx={{ opacity: 0.9 }}>
//                     per unit
//                   </Typography>
//                 </Box>

//                 <Divider sx={{ marginY: 2 }} />

//                 <Typography variant="body2" sx={{ fontWeight: 500, marginBottom: 2 }}>
//                   Investment Summary
//                 </Typography>

//                 <Box sx={{ marginBottom: 2 }}>
//                   <Box sx={{ display: 'flex', justifyContent: 'space-between', marginBottom: 1 }}>
//                     <Typography variant="body2" sx={{ color: '#666' }}>
//                       Units
//                     </Typography>
//                     <Typography variant="body2" sx={{ fontWeight: 500 }}>
//                       {watchedValues.purchaseUnits?.toFixed(2) || '0.00'}
//                     </Typography>
//                   </Box>

//                   <Box sx={{ display: 'flex', justifyContent: 'space-between', marginBottom: 1 }}>
//                     <Typography variant="body2" sx={{ color: '#666' }}>
//                       Unit Price
//                     </Typography>
//                     <Typography variant="body2" sx={{ fontWeight: 500 }}>
//                       {formatCurrency(selectedUnitClass?.unitPrice || 0)}
//                     </Typography>
//                   </Box>

//                   <Divider sx={{ marginY: 1 }} />

//                   <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
//                     <Typography variant="body2" sx={{ fontWeight: 500 }}>
//                       Base Amount
//                     </Typography>
//                     <Typography variant="body2" sx={{ fontWeight: 600, color: '#1976d2' }}>
//                       {formatCurrency(getTotalCost())}
//                     </Typography>
//                   </Box>
//                 </Box>

//                 {/* Dynamic Operational Fee */}
//                 <Box
//                   sx={{
//                     marginBottom: 2,
//                     padding: '12px',
//                     backgroundColor: '#f0f7ff',
//                     borderRadius: 2
//                   }}
//                 >
//                   {feeLoadingStatus === 'loading' ? (
//                     <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                       <CircularProgress size={16} />
//                       <Typography variant="body2" sx={{ color: '#999', fontSize: '0.8rem' }}>
//                         Loading fee configuration...
//                       </Typography>
//                     </Box>
//                   ) : feeLoadingStatus === 'error' ? (
//                     <Alert severity="warning" sx={{ padding: '4px 8px', fontSize: '0.75rem' }}>
//                       Unable to load operational fee
//                     </Alert>
//                   ) : (
//                     <>
//                       <Typography
//                         variant="body2"
//                         color="textSecondary"
//                         sx={{ fontWeight: 'medium', marginBottom: 0.5, fontSize: '0.8rem' }}
//                       >
//                         Operational Fee ({operationPercentage}%): {formatCurrency(operationCharge)}
//                       </Typography>
//                       <Typography
//                         variant="body1"
//                         sx={{
//                           fontWeight: 'bold',
//                           marginTop: 0.5,
//                           color: '#1976d2',
//                           fontSize: { xs: '0.85rem', md: '0.9rem' }
//                         }}
//                       >
//                         Total with Fee: {formatCurrency(totalWithFee)}
//                       </Typography>
//                     </>
//                   )}
//                 </Box>

//                 {/* Capacity Section */}
//                 <Divider sx={{ marginY: 2 }} />
//                 <Typography variant="body2" sx={{ fontWeight: 500, marginBottom: 2 }}>
//                   Investment Capacity
//                 </Typography>

//                 {capacityLoading ? (
//                   <Box sx={{ display: 'flex', justifyContent: 'center', padding: 1 }}>
//                     <CircularProgress size={20} />
//                   </Box>
//                 ) : capacitySummary ? (
//                   <Box
//                     sx={{
//                       padding: 1.5,
//                       backgroundColor: checkCapacitySufficient(totalWithFee)
//                         ? '#e8f5e9'
//                         : '#ffebee',
//                       borderRadius: 2,
//                       border: `1px solid ${
//                         checkCapacitySufficient(totalWithFee) ? '#4caf50' : '#f44336'
//                       }`,
//                       marginBottom: 2
//                     }}
//                   >
//                     <Box sx={{ display: 'flex', justifyContent: 'space-between', marginBottom: 1 }}>
//                       <Typography variant="body2" sx={{ color: '#666' }}>
//                         Available
//                       </Typography>
//                       <Typography
//                         variant="body2"
//                         sx={{
//                           fontWeight: 600,
//                           color: checkCapacitySufficient(totalWithFee) ? '#2e7d32' : '#c62828'
//                         }}
//                       >
//                         {formatCurrency(capacitySummary.my_capacity || 0)}
//                       </Typography>
//                     </Box>

//                     <Box sx={{ display: 'flex', justifyContent: 'space-between', marginBottom: 1 }}>
//                       <Typography variant="body2" sx={{ color: '#666' }}>
//                         Requesting
//                       </Typography>
//                       <Typography variant="body2" sx={{ fontWeight: 500 }}>
//                         {formatCurrency(totalWithFee)}
//                       </Typography>
//                     </Box>

//                     <Divider sx={{ marginY: 1 }} />

//                     <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
//                       <Typography variant="body2" sx={{ fontWeight: 500 }}>
//                         After Purchase
//                       </Typography>
//                       <Typography
//                         variant="body2"
//                         sx={{
//                           fontWeight: 600,
//                           color: checkCapacitySufficient(totalWithFee) ? '#1976d2' : '#c62828'
//                         }}
//                       >
//                         {formatCurrency(getCapacityAfterPurchase(totalWithFee))}
//                       </Typography>
//                     </Box>

//                     {!checkCapacitySufficient(totalWithFee) && totalWithFee > 0 && (
//                       <Alert
//                         severity="error"
//                         sx={{ marginTop: 1.5, padding: '4px 8px', fontSize: '0.75rem' }}
//                       >
//                         Insufficient capacity! Reduce amount or increase capacity.
//                       </Alert>
//                     )}
//                   </Box>
//                 ) : (
//                   <Alert severity="warning" sx={{ padding: '4px 8px', fontSize: '0.75rem' }}>
//                     Unable to load capacity data.
//                   </Alert>
//                 )}
//               </Paper>
//             </Grid>

//             {/* Form Panel */}
//             <Grid item xs={12} md={8}>
//               <Paper sx={{ padding: { xs: 2, md: 4 }, borderRadius: 3 }}>
//                 <Typography
//                   variant="body1"
//                   sx={{
//                     fontWeight: 500,
//                     marginBottom: 2,
//                     display: 'flex',
//                     alignItems: 'center'
//                   }}
//                 >
//                   <MdPerson size={18} color="#1976d2" style={{ marginRight: 8 }} />
//                   Current Investor
//                 </Typography>

//                 <Box
//                   sx={{
//                     display: 'flex',
//                     alignItems: 'center',
//                     padding: 2,
//                     backgroundColor: '#e3f2fd',
//                     borderRadius: 2,
//                     border: '1px solid #1976d2',
//                     marginBottom: 3
//                   }}
//                 >
//                   <Avatar
//                     src={loggedUserAvatarUrl || undefined}
//                     sx={{ width: 48, height: 48, marginRight: 2 }}
//                   >
//                     {watchedValues.investorName?.charAt(0) || 'U'}
//                   </Avatar>
//                   <Box sx={{ flex: 1 }}>
//                     <Typography variant="body1" sx={{ fontWeight: 500 }}>
//                       {watchedValues.investorName}
//                     </Typography>
//                     <Typography variant="body2" sx={{ color: '#666' }}>
//                       {watchedValues.investorsEmailId}
//                     </Typography>
//                   </Box>
//                   <Button variant="outlined" size="small" onClick={handleSelectSelf}>
//                     Reset to Self
//                   </Button>
//                 </Box>

//                 {/* Hidden fields */}
//                 <Controller
//                   name="investorName"
//                   control={control}
//                   render={({ field }) => <input type="hidden" {...field} />}
//                 />
//                 <Controller
//                   name="investorsEmailId"
//                   control={control}
//                   render={({ field }) => <input type="hidden" {...field} />}
//                 />
//                 <Controller
//                   name="investorAvatar"
//                   control={control}
//                   render={({ field }) => <input type="hidden" {...field} />}
//                 />

//                 <Divider sx={{ marginY: 3 }} />

//                 <Typography
//                   variant="body1"
//                   sx={{
//                     fontWeight: 500,
//                     marginBottom: 2,
//                     display: 'flex',
//                     alignItems: 'center'
//                   }}
//                 >
//                   <FaCalculator size={16} color="#1976d2" style={{ marginRight: 8 }} />
//                   Investment Calculation
//                 </Typography>

//                 <Grid container spacing={2}>
//                   {!marketplaceData && (
//                     <Grid item xs={12}>
//                       <Controller
//                         name="calculationType"
//                         control={control}
//                         render={({ field: { onChange, value } }) => (
//                           <FormControl component="fieldset">
//                             <FormLabel component="legend">Calculate by</FormLabel>
//                             <RadioGroup
//                               row
//                               value={value}
//                               onChange={(e) => {
//                                 const newValue = e.target.value as 'amount' | 'units';
//                                 onChange(newValue);
//                                 handleCalculationTypeChange(newValue);
//                               }}
//                             >
//                               <FormControlLabel
//                                 value="amount"
//                                 control={<Radio />}
//                                 label="Investment Amount"
//                               />
//                               <FormControlLabel
//                                 value="units"
//                                 control={<Radio />}
//                                 label="Number of Units"
//                               />
//                             </RadioGroup>
//                           </FormControl>
//                         )}
//                       />
//                     </Grid>
//                   )}

//                   {watchedValues.calculationType === 'amount' && !marketplaceData ? (
//                     <>
//                       <Grid item xs={12} sm={6}>
//                         <Controller
//                           name="totalInvestmentAmt"
//                           control={control}
//                           render={({ field }) => (
//                             <TextField
//                               {...field}
//                               fullWidth
//                               label="Investment Amount"
//                               type="number"
//                               error={!!errors.totalInvestmentAmt}
//                               helperText={
//                                 errors.totalInvestmentAmt?.message ||
//                                 `Minimum ${formatCurrency(
//                                   selectedUnitClass?.minimumInvestment || 0
//                                 )}`
//                               }
//                               InputProps={{
//                                 startAdornment: (
//                                   <InputAdornment position="start">AUD</InputAdornment>
//                                 )
//                               }}
//                               onChange={(e) => {
//                                 const value = parseFloat(e.target.value) || 0;
//                                 field.onChange(value);
//                                 handleAmountChange(value);
//                               }}
//                             />
//                           )}
//                         />
//                       </Grid>
//                       <Grid item xs={12} sm={6}>
//                         <Controller
//                           name="purchaseUnits"
//                           control={control}
//                           render={({ field }) => (
//                             <TextField
//                               {...field}
//                               fullWidth
//                               label="Number of Units"
//                               type="number"
//                               error={!!errors.purchaseUnits}
//                               helperText={errors.purchaseUnits?.message || 'Units can be decimal'}
//                               inputProps={{ step: 0.01 }}
//                               onChange={(e) => {
//                                 const value = parseFloat(e.target.value) || 0;
//                                 field.onChange(value);
//                                 handleUnitsChange(value);
//                               }}
//                             />
//                           )}
//                         />
//                       </Grid>
//                     </>
//                   ) : (
//                     <>
//                       <Grid item xs={12} sm={6}>
//                         <Controller
//                           name="purchaseUnits"
//                           control={control}
//                           render={({ field }) => (
//                             <TextField
//                               {...field}
//                               fullWidth
//                               label="Number of Units"
//                               type="number"
//                               error={!!errors.purchaseUnits}
//                               helperText={
//                                 marketplaceData
//                                   ? 'Fixed from marketplace request'
//                                   : errors.purchaseUnits?.message
//                               }
//                               inputProps={{ step: 0.01 }}
//                               disabled={Boolean(marketplaceData)}
//                               onChange={(e) => {
//                                 const value = parseFloat(e.target.value) || 0;
//                                 field.onChange(value);
//                                 if (!marketplaceData) {
//                                   handleUnitsChange(value);
//                                 }
//                               }}
//                             />
//                           )}
//                         />
//                       </Grid>
//                       <Grid item xs={12} sm={6}>
//                         <TextField
//                           fullWidth
//                           label="Calculated Amount"
//                           value={formatCurrency(watchedValues.totalInvestmentAmt || 0)}
//                           disabled
//                         />
//                       </Grid>
//                     </>
//                   )}

//                   <Grid item xs={12}>
//                     <Box sx={{ marginTop: 3, textAlign: 'center' }}>
//                       <Alert severity="info" sx={{ marginBottom: 3 }}>
//                         {marketplaceData
//                           ? "This purchase will be matched with the seller's request and reviewed by the fund manager."
//                           : 'Purchase request will be reviewed by the fund manager.'}
//                       </Alert>

//                       {capacitySummary &&
//                         !checkCapacitySufficient(totalWithFee) &&
//                         totalWithFee > 0 && (
//                           <Alert
//                             severity="error"
//                             icon={<CancelIcon />}
//                             sx={{ marginBottom: 3, backgroundColor: '#ffebee' }}
//                           >
//                             <Typography variant="h6" sx={{ fontWeight: 600, color: '#c62828' }}>
//                               Insufficient Funds
//                             </Typography>
//                             <Typography variant="body2" sx={{ marginTop: 1 }}>
//                               Available: {formatCurrency(capacitySummary.my_capacity || 0)} |
//                               Requesting: {formatCurrency(totalWithFee)} | Shortfall:{' '}
//                               {formatCurrency(Math.abs(getCapacityAfterPurchase(totalWithFee)))}
//                             </Typography>
//                           </Alert>
//                         )}

//                       <Button
//                         type="submit"
//                         variant="contained"
//                         size="large"
//                         disabled={
//                           !isValid ||
//                           Boolean(loading) ||
//                           !capacitySummary ||
//                           !checkCapacitySufficient(totalWithFee)
//                         }
//                         startIcon={loading ? <CircularProgress size={20} /> : null}
//                         sx={{
//                           textTransform: 'none',
//                           fontWeight: 500,
//                           borderRadius: 2,
//                           padding: '12px 36px'
//                         }}
//                       >
//                         {loading
//                           ? 'Submitting...'
//                           : !capacitySummary
//                           ? 'Loading...'
//                           : !checkCapacitySufficient(totalWithFee)
//                           ? `Need ${formatCurrency(totalWithFee - getRemainingCapacity())} More`
//                           : marketplaceData
//                           ? `Buy ${watchedValues.purchaseUnits} Units`
//                           : 'Submit Purchase Request'}
//                       </Button>
//                     </Box>
//                   </Grid>
//                 </Grid>
//               </Paper>
//             </Grid>
//           </Grid>
//         </form>
//       )}

//       {/* Certificate Viewer modal on purchase success */}
//       {showCertificateModal && certificatePayload && (
//         <CertificateViewer
//           mode={certificatePayload.mode}
//           previewData={certificatePayload.previewData}
//           payload={certificatePayload.payload}
//           onClose={handleCertificateClose}
//         />
//       )}

//       {/* Snackbar */}
//       <Snackbar
//         open={snackbar.open}
//         autoHideDuration={6000}
//         onClose={() => setSnackbar((prev: SnackbarState) => ({ ...prev, open: false }))}
//         anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
//       >
//         <Alert
//           onClose={() => setSnackbar((prev: SnackbarState) => ({ ...prev, open: false }))}
//           severity={snackbar.severity}
//           sx={{ width: '100%', borderRadius: 2 }}
//         >
//           {snackbar.message}
//         </Alert>
//       </Snackbar>
//     </Container>
//   );
// };

// export default UnitPurchase;




import {
  Alert,
  Avatar,
  Box,
  Button,
  Card,
  CardContent,
  Chip,
  CircularProgress,
  Container,
  Divider,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  InputAdornment,
  Paper,
  Radio,
  RadioGroup,
  Snackbar,
  TextField,
  Typography,
  Modal,
  Stack,
  useTheme,
  useMediaQuery
} from '@mui/material';
import React, { useMemo } from 'react';
import { Controller } from 'react-hook-form';
import {
  FaArrowRight,
  FaArrowUp,
  FaCalculator,
  FaCoins,
  FaMoneyBillWave,
  FaPiggyBank,
  FaShoppingCart,
  FaSignature
} from 'react-icons/fa';
import { MdCancel as CancelIcon, MdPerson } from 'react-icons/md';
import { TbArrowsExchange } from 'react-icons/tb';
import { useUnitPurchaseLogic } from './UnitPurchaseLogic';
import { formatCurrency, getGroupId, getLoggedInUser, getRiskColor } from './UnitPurchaseUtils';
import { UnitClass, SnackbarState, SubscriptionFormData } from './UnitPurchaseTypes';
import CertificateViewer from '../certificate/CertificateViewer';
import { useDispatch, useSelector } from 'react-redux';
import {
  manageTrustConfiguration,
  selectTrustConfig
} from 'slices/fundManagementInvestment/fundManagementConfigurationSlice';
import { useAppSelector } from 'app/hooks';
import { useNavigate } from 'react-router-dom';

const UnitPurchase: React.FC = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const selectedProjectId = useAppSelector((state) => state.homeTilesServices.selectedProjectId);
  const projectIdForTrustConfig = selectedProjectId || getGroupId();
  const loggedInUser = useMemo(() => getLoggedInUser(), []);
  const trustConfig = useSelector(selectTrustConfig);
  const trustConfigLoading = useSelector(
    (state: any) => state.fundManagementConfiguration?.loading
  );

  const {
    unitClasses,
    selectedUnitClass,
    showForm,
    loading,
    landingDataStatus,
    capacitySummary,
    capacityLoading,
    loggedUserAvatarUrl,
    snackbar,
    feeLoadingStatus,
    marketplaceData,
    control,
    handleSubmit,
    watchedValues,
    errors,
    isValid,
    setValue,
    operationPercentage,
    operationCharge,
    totalWithFee,
    setShowForm,
    setSnackbar,
    handleUnitClassSelect,
    handleSelectSelf,
    handleCalculationTypeChange,
    handleAmountChange,
    handleUnitsChange,
    onSubmit,
    checkCapacitySufficient,
    getRemainingCapacity,
    getCapacityAfterPurchase,
    getTotalCost,
    getDataSourceStatus,
    showCertificateModal,
    certificatePayload,
    handleCertificateClose
  } = useUnitPurchaseLogic();

  // Load trust configuration to check investor signature
  React.useEffect(() => {
    if (projectIdForTrustConfig && loggedInUser?.email) {
      dispatch(
        manageTrustConfiguration({
          action: 'get',
          groupId: projectIdForTrustConfig,
          serviceId: 'fundManagementInvestment',
          isAdmin: false,
          investorEmail: loggedInUser.email
        })
      );
    }
  }, [projectIdForTrustConfig, loggedInUser, dispatch]);

  const investorSignatureConfigured = !!trustConfig?.investorSignatureBase64;
  const signatureMissingModal = !investorSignatureConfigured && !trustConfigLoading;
  const hasPositivePurchaseValues =
    Number(watchedValues.purchaseUnits || 0) > 0 && Number(watchedValues.totalInvestmentAmt || 0) > 0;
  const hasCapacityData = !!capacitySummary && typeof capacitySummary.my_capacity === 'number';
  const hasSufficientCapacity = hasCapacityData ? checkCapacitySufficient(totalWithFee) : true;

  const handleGoToConfiguration = () => {
    navigate('/fundManagementInvestment/configuration'); 
  };

  const handleDirectSubmit = React.useCallback(
    (event: React.FormEvent<HTMLFormElement>) => {
      event.preventDefault();

      const normalizedData: SubscriptionFormData = {
        investorName: watchedValues.investorName || loggedInUser.name || 'Investor',
        investorsEmailId: watchedValues.investorsEmailId || loggedInUser.email || '',
        investorAvatar: watchedValues.investorAvatar || loggedInUser.avatar || '',
        calculationType: watchedValues.calculationType === 'units' ? 'units' : 'amount',
        purchaseUnits: Number(watchedValues.purchaseUnits) || 0,
        totalInvestmentAmt: Number(watchedValues.totalInvestmentAmt) || 0,
        subscriptionType:
          watchedValues.subscriptionType === 'growthUnits' ? 'growthUnits' : 'incomeUnits'
      };

      if (normalizedData.purchaseUnits <= 0 || normalizedData.totalInvestmentAmt <= 0) {
        setSnackbar({
          open: true,
          message: 'Please enter valid units and amount before submitting.',
          severity: 'error'
        });
        return;
      }

      onSubmit(normalizedData);
    },
    [watchedValues, loggedInUser, setSnackbar, onSubmit]
  );

  const dataStatus = getDataSourceStatus();

  if (loading || landingDataStatus === 'idle') {
    return (
      <Container
        maxWidth="xl"
        sx={{
          padding: 3,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '50vh'
        }}
      >
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
          <CircularProgress size={40} />
          <Typography variant="body1" color="text.secondary">
            Loading unit class data...
          </Typography>
        </Box>
      </Container>
    );
  }

  return (
    <>
      <Container maxWidth="xl" sx={{ padding: { xs: 1, sm: 2, md: 3 }, minHeight: '100vh' }}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            marginBottom: { xs: 2, md: 3 },
            flexWrap: 'wrap',
            gap: { xs: 1, md: 0 }
          }}
        >
          <FaMoneyBillWave
            size={isMobile ? 20 : 24}
            color="#1976d2"
            style={{ marginRight: isMobile ? 8 : 12, flexShrink: 0 }}
          />
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Typography
              variant="h6"
              component="h1"
              sx={{
                fontWeight: 500,
                color: '#333',
                fontSize: { xs: '1rem', md: '1.2rem' }
              }}
            >
              Unit Purchase
            </Typography>
            <Typography
              variant="body2"
              sx={{
                color: '#666',
                marginTop: 0.5,
                fontSize: { xs: '0.75rem', md: '0.8rem' }
              }}
            >
              Select your preferred unit class and subscribe to our trust fund
              <span style={{ marginLeft: '8px', color: dataStatus.color }}>{dataStatus.text}</span>
            </Typography>
          </Box>
        </Box>

        {marketplaceData && (
          <Alert
            severity="info"
            icon={<FaShoppingCart size={20} />}
            sx={{
              marginBottom: 3,
              borderRadius: 2,
              border: '2px solid #1976d2'
            }}
          >
            <Typography
              variant="body1"
              sx={{ fontWeight: 600, marginBottom: 1, fontSize: '0.9rem' }}
            >
              Buying from Marketplace
            </Typography>
            <Typography variant="body2" sx={{ marginBottom: 1, fontSize: '0.85rem' }}>
              You are purchasing <strong>{marketplaceData.sellUnits} units</strong> from{' '}
              <strong>{marketplaceData.sellerName}</strong>
            </Typography>
            <Box sx={{ display: 'flex', gap: 2, marginTop: 1, flexWrap: 'wrap' }}>
              <Chip
                size="small"
                label={`Unit Price: ${formatCurrency(marketplaceData.unitPrice)}`}
                sx={{ fontSize: '0.75rem' }}
              />
              <Chip
                size="small"
                label={`Total: ${formatCurrency(
                  marketplaceData.sellUnits * marketplaceData.unitPrice
                )}`}
                color="primary"
                sx={{ fontSize: '0.75rem' }}
              />
              <Chip
                size="small"
                label={
                  marketplaceData.subscriptionType === 'incomeUnits'
                    ? 'Income Units'
                    : 'Growth Units'
                }
                color="secondary"
                sx={{ fontSize: '0.75rem' }}
              />
            </Box>
          </Alert>
        )}

        {!investorSignatureConfigured && !trustConfigLoading && (
          <Alert
            severity="warning"
            icon={<FaSignature />}
            sx={{ mb: 3, border: '2px solid #ff9800' }}
          >
            <Typography variant="body1" sx={{ fontWeight: 600 }}>
              Investor Signature Required
            </Typography>
            <Typography variant="body2">
              You must configure your digital signature in your profile before purchasing units.
              This is required for legally binding applications and certificates.
            </Typography>
          </Alert>
        )}

        {!showForm ? (
          <>
            <Typography
              variant="body1"
              sx={{
                fontWeight: 500,
                marginBottom: { xs: 2, md: 2.5 },
                color: '#333',
                fontSize: { xs: '0.9rem', md: '1rem' }
              }}
            >
              Choose Your Investment Strategy
            </Typography>
            <Grid container spacing={{ xs: 2, md: 4 }}>
              {unitClasses.map((unitClass: UnitClass) => (
                <Grid item xs={12} md={6} key={unitClass.id}>
                  <Card
                    sx={{
                      height: '100%',
                      cursor: investorSignatureConfigured ? 'pointer' : 'not-allowed',
                      opacity: investorSignatureConfigured ? 1 : 0.65,
                      transition: 'all 0.3s ease',
                      borderRadius: { xs: 2, md: 3 },
                      border: '2px solid #e0e0e0',
                      position: 'relative',
                      overflow: 'hidden',
                      '&:hover': investorSignatureConfigured
                        ? {
                            transform: 'translateY(-4px)',
                            boxShadow: '0 8px 20px rgba(0,0,0,0.15)',
                            border: '2px solid #1976d2'
                          }
                        : {}
                    }}
                    onClick={() => investorSignatureConfigured && handleUnitClassSelect(unitClass)}
                  >
                    <Box
                      sx={{
                        background:
                          unitClass.type === 'Income'
                            ? 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)'
                            : 'linear-gradient(135deg, #fa709a 0%, #fee140 100%)',
                        padding: { xs: 2, md: 3 },
                        color: 'white'
                      }}
                    >
                      <Box
                        sx={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center'
                        }}
                      >
                        <Box sx={{ flex: 1, minWidth: 0 }}>
                          <Box
                            sx={{ display: 'flex', alignItems: 'center', gap: 1, marginBottom: 1 }}
                          >
                            <Typography
                              variant="h6"
                              sx={{
                                fontWeight: 500,
                                fontSize: { xs: '0.95rem', md: '1.1rem' },
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap'
                              }}
                            >
                              {unitClass.name}
                            </Typography>
                            <Chip
                              label={unitClass.id.includes('live') ? 'Live' : 'Initial'}
                              size="small"
                              sx={{
                                backgroundColor: unitClass.id.includes('live')
                                  ? 'rgba(76, 175, 80, 0.3)'
                                  : 'rgba(158, 158, 158, 0.3)',
                                color: 'white',
                                fontWeight: 500,
                                fontSize: '0.6rem',
                                height: 20
                              }}
                            />
                          </Box>
                          <Typography
                            variant="h6"
                            sx={{
                              fontWeight: 600,
                              fontSize: { xs: '1.1rem', md: '1.3rem' }
                            }}
                          >
                            {formatCurrency(unitClass.unitPrice)}
                          </Typography>
                          <Typography
                            variant="body2"
                            sx={{
                              opacity: 0.9,
                              fontSize: { xs: '0.7rem', md: '0.75rem' }
                            }}
                          >
                            per unit
                          </Typography>
                        </Box>
                        <Box sx={{ textAlign: 'center', flexShrink: 0, marginLeft: 1 }}>
                          {unitClass.type === 'Income' ? (
                            <FaPiggyBank size={isMobile ? 28 : 32} />
                          ) : (
                            <FaArrowUp size={isMobile ? 28 : 32} />
                          )}
                        </Box>
                      </Box>
                    </Box>

                    <CardContent sx={{ padding: { xs: 2, md: 3 } }}>
                      <Typography
                        variant="body1"
                        sx={{
                          marginBottom: 2,
                          color: '#666',
                          lineHeight: 1.6,
                          fontSize: { xs: '0.8rem', md: '0.85rem' }
                        }}
                      >
                        {unitClass.description}
                      </Typography>

                      <Grid container spacing={{ xs: 1, md: 2 }} sx={{ marginBottom: 3 }}>
                        <Grid item xs={6}>
                          <Box
                            sx={{
                              textAlign: 'center',
                              padding: { xs: 1.5, md: 2 },
                              backgroundColor: '#f5f5f5',
                              borderRadius: 2
                            }}
                          >
                            <Typography
                              variant="body1"
                              sx={{
                                fontWeight: 500,
                                color: '#333',
                                fontSize: { xs: '0.8rem', md: '0.9rem' }
                              }}
                            >
                              {unitClass.totalUnits.toLocaleString()}
                            </Typography>
                            <Typography
                              variant="caption"
                              sx={{
                                color: '#666',
                                fontSize: { xs: '0.65rem', md: '0.7rem' }
                              }}
                            >
                              Total Units
                            </Typography>
                          </Box>
                        </Grid>
                        <Grid item xs={6}>
                          <Box
                            sx={{
                              textAlign: 'center',
                              padding: { xs: 1.5, md: 2 },
                              backgroundColor: '#f5f5f5',
                              borderRadius: 2
                            }}
                          >
                            <Typography
                              variant="body1"
                              sx={{
                                fontWeight: 500,
                                color: '#333',
                                fontSize: { xs: '0.8rem', md: '0.9rem' },
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap'
                              }}
                            >
                              {unitClass.totalNAV === 0
                                ? '0'
                                : isMobile
                                ? formatCurrency(unitClass.totalNAV).replace('$', '').slice(0, -3) +
                                  'K'
                                : formatCurrency(unitClass.totalNAV)}
                            </Typography>
                            <Typography
                              variant="caption"
                              sx={{
                                color: '#666',
                                fontSize: { xs: '0.65rem', md: '0.7rem' }
                              }}
                            >
                              Total NAV
                            </Typography>
                          </Box>
                        </Grid>
                      </Grid>

                      <Typography
                        variant="body2"
                        sx={{
                          fontWeight: 500,
                          marginBottom: 2,
                          color: '#333',
                          fontSize: { xs: '0.75rem', md: '0.8rem' }
                        }}
                      >
                        Key Features
                      </Typography>
                      <Box sx={{ marginBottom: 3 }}>
                        {unitClass.features.map((feature: string, index: number) => (
                          <Typography
                            key={index}
                            variant="body2"
                            sx={{
                              color: '#666',
                              marginBottom: 0.5,
                              fontSize: { xs: '0.7rem', md: '0.75rem' }
                            }}
                          >
                            • {feature}
                          </Typography>
                        ))}
                      </Box>

                      <Box
                        sx={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          marginBottom: 2,
                          flexWrap: 'wrap',
                          gap: 1
                        }}
                      >
                        <Chip
                          label={`Risk: ${unitClass.riskLevel}`}
                          size="small"
                          sx={{
                            backgroundColor: getRiskColor(unitClass.riskLevel),
                            color: 'white',
                            fontWeight: 500,
                            fontSize: { xs: '0.6rem', md: '0.65rem' }
                          }}
                        />
                        <Typography
                          variant="body2"
                          sx={{
                            color: '#666',
                            fontSize: { xs: '0.7rem', md: '0.75rem' }
                          }}
                        >
                          Min: {formatCurrency(unitClass.minimumInvestment)}
                        </Typography>
                      </Box>

                      <Button
                        fullWidth
                        variant="contained"
                        endIcon={<FaArrowRight />}
                        disabled={!investorSignatureConfigured || Boolean(loading)}
                        sx={{
                          backgroundColor: '#1976d2',
                          '&:hover': { backgroundColor: '#1565c0' },
                          textTransform: 'none',
                          fontWeight: 500,
                          borderRadius: 2,
                          padding: { xs: '10px', md: '12px' },
                          fontSize: { xs: '0.8rem', md: '0.85rem' }
                        }}
                      >
                        {investorSignatureConfigured
                          ? `Subscribe to ${unitClass.name}`
                          : 'Signature Required'}
                      </Button>
                    </CardContent>
                  </Card>
                </Grid>
              ))}
            </Grid>
          </>
        ) : (
          <Box
            sx={{
              filter: investorSignatureConfigured ? 'none' : 'blur(6px)',
              pointerEvents: investorSignatureConfigured ? 'auto' : 'none'
            }}
          >
            <form onSubmit={handleDirectSubmit}>
              <Grid container spacing={{ xs: 2, md: 4 }}>
                <Grid item xs={12} md={4}>
                  <Paper
                    sx={{
                      padding: { xs: 2, md: 3 },
                      borderRadius: 3,
                      position: { xs: 'static', md: 'sticky' },
                      top: 150,
                      height: 'fit-content'
                    }}
                  >
                    <Typography
                      variant="body1"
                      sx={{
                        fontWeight: 500,
                        marginBottom: 2,
                        display: 'flex',
                        alignItems: 'center',
                        fontSize: { xs: '0.85rem', md: '0.9rem' }
                      }}
                    >
                      <FaCoins
                        size={isMobile ? 14 : 16}
                        color="#1976d2"
                        style={{ marginRight: 8 }}
                      />
                      Selected Unit Class
                    </Typography>

                    {!marketplaceData && (
                      <Button
                        fullWidth
                        variant="outlined"
                        startIcon={<TbArrowsExchange />}
                        onClick={() => setShowForm(false)}
                        disabled={Boolean(loading)}
                        sx={{
                          textTransform: 'none',
                          marginBottom: 2,
                          fontSize: { xs: '0.75rem', md: '0.8rem' },
                          fontWeight: 500,
                          borderRadius: 2
                        }}
                      >
                        Change Unit Class
                      </Button>
                    )}

                    <Box
                      sx={{
                        background:
                          selectedUnitClass?.type === 'Income'
                            ? 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)'
                            : 'linear-gradient(135deg, #fa709a 0%, #fee140 100%)',
                        padding: { xs: 1.5, md: 2 },
                        borderRadius: 2,
                        color: 'white',
                        marginBottom: 3
                      }}
                    >
                      <Typography variant="body1" sx={{ fontWeight: 500, marginBottom: 1 }}>
                        {selectedUnitClass?.name}
                      </Typography>
                      <Typography variant="h6" sx={{ fontWeight: 600 }}>
                        {formatCurrency(selectedUnitClass?.unitPrice || 0)}
                      </Typography>
                      <Typography variant="body2" sx={{ opacity: 0.9 }}>
                        per unit
                      </Typography>
                    </Box>

                    <Divider sx={{ marginY: 2 }} />

                    <Typography variant="body2" sx={{ fontWeight: 500, marginBottom: 2 }}>
                      Investment Summary
                    </Typography>

                    <Box sx={{ marginBottom: 2 }}>
                      <Box
                        sx={{ display: 'flex', justifyContent: 'space-between', marginBottom: 1 }}
                      >
                        <Typography variant="body2" sx={{ color: '#666' }}>
                          Units
                        </Typography>
                        <Typography variant="body2" sx={{ fontWeight: 500 }}>
                          {(Number(watchedValues.purchaseUnits) || 0).toFixed(2)}
                        </Typography>
                      </Box>

                      <Box
                        sx={{ display: 'flex', justifyContent: 'space-between', marginBottom: 1 }}
                      >
                        <Typography variant="body2" sx={{ color: '#666' }}>
                          Unit Price
                        </Typography>
                        <Typography variant="body2" sx={{ fontWeight: 500 }}>
                          {formatCurrency(selectedUnitClass?.unitPrice || 0)}
                        </Typography>
                      </Box>

                      <Divider sx={{ marginY: 1 }} />

                      <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                        <Typography variant="body2" sx={{ fontWeight: 500 }}>
                          Base Amount
                        </Typography>
                        <Typography variant="body2" sx={{ fontWeight: 600, color: '#1976d2' }}>
                          {formatCurrency(getTotalCost())}
                        </Typography>
                      </Box>
                    </Box>

                    <Box
                      sx={{
                        marginBottom: 2,
                        padding: '12px',
                        backgroundColor: '#f0f7ff',
                        borderRadius: 2
                      }}
                    >
                      {feeLoadingStatus === 'loading' ? (
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                          <CircularProgress size={16} />
                          <Typography variant="body2" sx={{ color: '#999', fontSize: '0.8rem' }}>
                            Loading fee configuration...
                          </Typography>
                        </Box>
                      ) : feeLoadingStatus === 'error' ? (
                        <Alert severity="warning" sx={{ padding: '4px 8px', fontSize: '0.75rem' }}>
                          Unable to load operational fee
                        </Alert>
                      ) : (
                        <>
                          <Typography
                            variant="body2"
                            color="textSecondary"
                            sx={{ fontWeight: 'medium', marginBottom: 0.5, fontSize: '0.8rem' }}
                          >
                            Operational Fee ({operationPercentage}%):{' '}
                            {formatCurrency(operationCharge)}
                          </Typography>
                          <Typography
                            variant="body1"
                            sx={{
                              fontWeight: 'bold',
                              marginTop: 0.5,
                              color: '#1976d2',
                              fontSize: { xs: '0.85rem', md: '0.9rem' }
                            }}
                          >
                            Total with Fee: {formatCurrency(totalWithFee)}
                          </Typography>
                        </>
                      )}
                    </Box>

                    <Divider sx={{ marginY: 2 }} />
                    <Typography variant="body2" sx={{ fontWeight: 500, marginBottom: 2 }}>
                      Investment Capacity
                    </Typography>

                    {capacityLoading ? (
                      <Box sx={{ display: 'flex', justifyContent: 'center', padding: 1 }}>
                        <CircularProgress size={20} />
                      </Box>
                    ) : capacitySummary ? (
                      <Box
                        sx={{
                          padding: 1.5,
                          backgroundColor: checkCapacitySufficient(totalWithFee)
                            ? '#e8f5e9'
                            : '#ffebee',
                          borderRadius: 2,
                          border: `1px solid ${
                            checkCapacitySufficient(totalWithFee) ? '#4caf50' : '#f44336'
                          }`,
                          marginBottom: 2
                        }}
                      >
                        <Box
                          sx={{ display: 'flex', justifyContent: 'space-between', marginBottom: 1 }}
                        >
                          <Typography variant="body2" sx={{ color: '#666' }}>
                            Available
                          </Typography>
                          <Typography
                            variant="body2"
                            sx={{
                              fontWeight: 600,
                              color: checkCapacitySufficient(totalWithFee) ? '#2e7d32' : '#c62828'
                            }}
                          >
                            {formatCurrency(capacitySummary.my_capacity || 0)}
                          </Typography>
                        </Box>

                        <Box
                          sx={{ display: 'flex', justifyContent: 'space-between', marginBottom: 1 }}
                        >
                          <Typography variant="body2" sx={{ color: '#666' }}>
                            Requesting
                          </Typography>
                          <Typography variant="body2" sx={{ fontWeight: 500 }}>
                            {formatCurrency(totalWithFee)}
                          </Typography>
                        </Box>

                        <Divider sx={{ marginY: 1 }} />

                        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                          <Typography variant="body2" sx={{ fontWeight: 500 }}>
                            After Purchase
                          </Typography>
                          <Typography
                            variant="body2"
                            sx={{
                              fontWeight: 600,
                              color: checkCapacitySufficient(totalWithFee) ? '#1976d2' : '#c62828'
                            }}
                          >
                            {formatCurrency(getCapacityAfterPurchase(totalWithFee))}
                          </Typography>
                        </Box>

                        {!checkCapacitySufficient(totalWithFee) && totalWithFee > 0 && (
                          <Alert
                            severity="error"
                            sx={{ marginTop: 1.5, padding: '4px 8px', fontSize: '0.75rem' }}
                          >
                            Insufficient capacity! Reduce amount or increase capacity.
                          </Alert>
                        )}
                      </Box>
                    ) : (
                      <Alert severity="warning" sx={{ padding: '4px 8px', fontSize: '0.75rem' }}>
                        Unable to load capacity data.
                      </Alert>
                    )}
                  </Paper>
                </Grid>

                <Grid item xs={12} md={8}>
                  <Paper sx={{ padding: { xs: 2, md: 4 }, borderRadius: 3 }}>
                    <Typography
                      variant="body1"
                      sx={{
                        fontWeight: 500,
                        marginBottom: 2,
                        display: 'flex',
                        alignItems: 'center'
                      }}
                    >
                      <MdPerson size={18} color="#1976d2" style={{ marginRight: 8 }} />
                      Current Investor
                    </Typography>

                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        padding: 2,
                        backgroundColor: '#e3f2fd',
                        borderRadius: 2,
                        border: '1px solid #1976d2',
                        marginBottom: 3
                      }}
                    >
                      <Avatar
                        src={loggedUserAvatarUrl || undefined}
                        sx={{ width: 48, height: 48, marginRight: 2 }}
                      >
                        {watchedValues.investorName?.charAt(0) || 'U'}
                      </Avatar>
                      <Box sx={{ flex: 1 }}>
                        <Typography variant="body1" sx={{ fontWeight: 500 }}>
                          {watchedValues.investorName}
                        </Typography>
                        <Typography variant="body2" sx={{ color: '#666' }}>
                          {watchedValues.investorsEmailId}
                        </Typography>
                      </Box>
                      <Button variant="outlined" size="small" onClick={handleSelectSelf}>
                        Reset to Self
                      </Button>
                    </Box>

                    <Controller
                      name="investorName"
                      control={control}
                      render={({ field }) => <input type="hidden" {...field} />}
                    />
                    <Controller
                      name="investorsEmailId"
                      control={control}
                      render={({ field }) => <input type="hidden" {...field} />}
                    />
                    <Controller
                      name="investorAvatar"
                      control={control}
                      render={({ field }) => (
                        <input type="hidden" {...field} value={field.value ?? ''} />
                      )}
                    />

                    <Divider sx={{ marginY: 3 }} />

                    <Typography
                      variant="body1"
                      sx={{
                        fontWeight: 500,
                        marginBottom: 2,
                        display: 'flex',
                        alignItems: 'center'
                      }}
                    >
                      <FaCalculator size={16} color="#1976d2" style={{ marginRight: 8 }} />
                      Investment Calculation
                    </Typography>

                    <Grid container spacing={2}>
                      {!marketplaceData && (
                        <Grid item xs={12}>
                          <Controller
                            name="calculationType"
                            control={control}
                            render={({ field: { onChange, value } }) => (
                              <FormControl component="fieldset">
                                <FormLabel component="legend">Calculate by</FormLabel>
                                <RadioGroup
                                  row
                                  value={value}
                                  onChange={(e) => {
                                    const newValue = e.target.value as 'amount' | 'units';
                                    onChange(newValue);
                                    handleCalculationTypeChange(newValue);
                                  }}
                                >
                                  <FormControlLabel
                                    value="amount"
                                    control={<Radio />}
                                    label="Investment Amount"
                                  />
                                  <FormControlLabel
                                    value="units"
                                    control={<Radio />}
                                    label="Number of Units"
                                  />
                                </RadioGroup>
                              </FormControl>
                            )}
                          />
                        </Grid>
                      )}

                      {watchedValues.calculationType === 'amount' && !marketplaceData ? (
                        <>
                          <Grid item xs={12} sm={6}>
                            <Controller
                              name="totalInvestmentAmt"
                              control={control}
                              render={({ field }) => (
                                <TextField
                                  {...field}
                                  fullWidth
                                  label="Investment Amount"
                                  type="number"
                                  error={!!errors.totalInvestmentAmt}
                                  helperText={
                                    errors.totalInvestmentAmt?.message ||
                                    `Minimum ${formatCurrency(
                                      selectedUnitClass?.minimumInvestment || 0
                                    )}`
                                  }
                                  InputProps={{
                                    startAdornment: (
                                      <InputAdornment position="start">AUD</InputAdornment>
                                    )
                                  }}
                                  onChange={(e) => {
                                    const value = parseFloat(e.target.value) || 0;
                                    field.onChange(value);
                                    handleAmountChange(value);
                                  }}
                                />
                              )}
                            />
                          </Grid>
                          <Grid item xs={12} sm={6}>
                            <Controller
                              name="purchaseUnits"
                              control={control}
                              render={({ field }) => (
                                <TextField
                                  {...field}
                                  fullWidth
                                  label="Number of Units"
                                  type="number"
                                  error={!!errors.purchaseUnits}
                                  helperText={
                                    errors.purchaseUnits?.message || 'Units can be decimal'
                                  }
                                  inputProps={{ step: 0.01 }}
                                  onChange={(e) => {
                                    const value = parseFloat(e.target.value) || 0;
                                    field.onChange(value);
                                    handleUnitsChange(value);
                                  }}
                                />
                              )}
                            />
                          </Grid>
                        </>
                      ) : (
                        <>
                          <Grid item xs={12} sm={6}>
                            <Controller
                              name="purchaseUnits"
                              control={control}
                              render={({ field }) => (
                                <TextField
                                  {...field}
                                  fullWidth
                                  label="Number of Units"
                                  type="number"
                                  error={!!errors.purchaseUnits}
                                  helperText={
                                    marketplaceData
                                      ? 'Fixed from marketplace request'
                                      : errors.purchaseUnits?.message
                                  }
                                  inputProps={{ step: 0.01 }}
                                  disabled={Boolean(marketplaceData)}
                                  onChange={(e) => {
                                    const value = parseFloat(e.target.value) || 0;
                                    field.onChange(value);
                                    if (!marketplaceData) {
                                      handleUnitsChange(value);
                                    }
                                  }}
                                />
                              )}
                            />
                          </Grid>
                          <Grid item xs={12} sm={6}>
                            <TextField
                              fullWidth
                              label="Calculated Amount"
                              value={formatCurrency(watchedValues.totalInvestmentAmt || 0)}
                              disabled
                            />
                          </Grid>
                        </>
                      )}

                      <Grid item xs={12}>
                        <Box sx={{ marginTop: 3, textAlign: 'center' }}>
                          <Alert severity="info" sx={{ marginBottom: 3 }}>
                            {marketplaceData
                              ? "This purchase will be matched with the seller's request and reviewed by the fund manager."
                              : 'Purchase request will be reviewed by the fund manager.'}
                          </Alert>

                          {capacitySummary &&
                            !checkCapacitySufficient(totalWithFee) &&
                            totalWithFee > 0 && (
                              <Alert
                                severity="error"
                                icon={<CancelIcon />}
                                sx={{ marginBottom: 3, backgroundColor: '#ffebee' }}
                              >
                                <Typography variant="h6" sx={{ fontWeight: 600, color: '#c62828' }}>
                                  Insufficient Funds
                                </Typography>
                                <Typography variant="body2" sx={{ marginTop: 1 }}>
                                  Available: {formatCurrency(capacitySummary.my_capacity || 0)} |
                                  Requesting: {formatCurrency(totalWithFee)} | Shortfall:{' '}
                                  {formatCurrency(Math.abs(getCapacityAfterPurchase(totalWithFee)))}
                                </Typography>
                              </Alert>
                            )}

                          <Button
                            type="submit"
                            variant="contained"
                            size="large"
                            disabled={
                              Boolean(loading) ||
                              !hasPositivePurchaseValues ||
                              !hasSufficientCapacity ||
                              !investorSignatureConfigured
                            }
                            startIcon={loading ? <CircularProgress size={20} /> : null}
                            sx={{
                              textTransform: 'none',
                              fontWeight: 500,
                              borderRadius: 2,
                              padding: '12px 36px'
                            }}
                          >
                            {loading
                              ? 'Submitting...'
                              : !investorSignatureConfigured
                              ? 'Signature Required'
                                : !hasPositivePurchaseValues
                                ? 'Enter Valid Amount'
                                : !hasSufficientCapacity
                              ? `Need ${formatCurrency(totalWithFee - getRemainingCapacity())} More`
                              : marketplaceData
                              ? `Buy ${watchedValues.purchaseUnits} Units`
                              : 'Submit Purchase Request'}
                          </Button>
                        </Box>
                      </Grid>
                    </Grid>
                  </Paper>
                </Grid>
              </Grid>
            </form>
          </Box>
        )}

        {showCertificateModal && certificatePayload && (
          <CertificateViewer
            mode={certificatePayload.mode}
            previewData={certificatePayload.previewData}
            payload={certificatePayload.payload}
            onClose={handleCertificateClose}
          />
        )}

        <Snackbar
          open={snackbar.open}
          autoHideDuration={6000}
          onClose={() => setSnackbar((prev: SnackbarState) => ({ ...prev, open: false }))}
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        >
          <Alert
            onClose={() => setSnackbar((prev: SnackbarState) => ({ ...prev, open: false }))}
            severity={snackbar.severity}
            sx={{ width: '100%', borderRadius: 2 }}
          >
            {snackbar.message}
          </Alert>
        </Snackbar>
      </Container>

      <Modal open={signatureMissingModal}>
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: { xs: '90%', sm: '520px' },
            bgcolor: 'background.paper',
            borderRadius: 3,
            boxShadow: 24,
            p: 4,
            outline: 'none',
            textAlign: 'center'
          }}
        >
          <FaSignature size={64} color="#ff9800" style={{ marginBottom: 20 }} />
          <Typography variant="h5" sx={{ fontWeight: 600, mb: 2 }}>
            Digital Signature Required
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ mb: 4, lineHeight: 1.6 }}>
            Before purchasing units, you must configure your digital signature in your profile. This
            is mandatory for generating legally binding unit applications and certificates.
          </Typography>

          <Stack direction={isMobile ? 'column' : 'row'} spacing={2} justifyContent="center">
            <Button
              variant="contained"
              size="large"
              onClick={handleGoToConfiguration}
              startIcon={<FaSignature />}
              sx={{ minWidth: 240 }}
            >
              Set Up Signature Now
            </Button>
            <Button variant="outlined" size="large" onClick={() => setShowForm(false)}>
              Back to Unit Classes
            </Button>
          </Stack>
        </Box>
      </Modal>
    </>
  );
};

export default UnitPurchase;